/** Polish translations. */
export const pl = {
    seo: {
        "landing": {
            "title": "TMC Studio — narysuj dowolną taktykę w 30 sekund",
            "description": "Tablica taktyczna i planer treningów dla trenerów. Rysuj grafiki, twórz ćwiczenia i konspekty, a potem eksportuj PNG, GIF, SVG lub PDF."
        },
        "pricing": {
            "title": "Cennik — TMC Studio",
            "description": "Zacznij za darmo, bez konta. Porównaj plany Darmowy, Pro i Zespół. Pro daje nielimitowane projekty i eksport GIF/PDF."
        }
    },
    cookieBanner: {
        "label": "Zgoda na cookies",
        "message": "Używamy niezbędnych plików cookie, aby TMC Studio działało. Za Twoją zgodą stosujemy też cookies analityczne, by ulepszać produkt.",
        "accept": "Akceptuj wszystkie",
        "reject": "Odrzuć zbędne",
        "policy": "Polityka cookies"
    },
    pricingPage: {
        "hero": {
            "title": "Wybierz, jak chcesz korzystać z TMC Studio",
            "subtitle": "Zacznij za darmo, bez konta. Przejdź wyżej dopiero, gdy trafisz na realny limit."
        },
        "billing": {
            "monthly": "Miesięcznie",
            "yearly": "Rocznie",
            "yearlyHint": "2 miesiące gratis"
        },
        "plans": {
            "guestName": "Gość",
            "freeName": "Darmowy",
            "proName": "Pro",
            "teamName": "Zespół",
            "guestCta": "Otwórz tablicę",
            "freeCta": "Kontynuuj za darmo",
            "proCta": "Przejdź na Pro",
            "teamCta": "Przejdź na Zespół",
            "perMonth": "/mies.",
            "perYear": "/rok",
            "free": "Za darmo",
            "guestTagline": "Bez konta",
            "freeTagline": "Darmowy na zawsze po rejestracji",
            "proTagline": "Dla trenerów i twórców",
            "teamTagline": "Dla klubów i sztabu"
        },
        "matrix": {
            "feature": "Funkcja",
            "projects": "Projekty",
            "steps": "Kroki na projekt",
            "folders": "Foldery",
            "cloudSync": "Synchronizacja w chmurze",
            "exportPng": "Eksport PNG / JPG",
            "exportGif": "Eksport GIF",
            "exportPdf": "Eksport PDF",
            "seats": "Miejsca",
            "invite": "Zapraszanie członków",
            "unlimited": "Bez limitu"
        },
        "vatNote": "Ceny dla konsumentów w UE zawierają VAT. Firmy z ważnym numerem VAT-UE są rozliczane w procedurze odwrotnego obciążenia.",
        "faq": {
            "title": "Pytania o rozliczenia",
            "q1": "Czy Darmowy jest naprawdę darmowy?",
            "a1": "Tak. To nie okres próbny — pozostaje darmowy na zawsze po założeniu konta. Bez karty.",
            "q2": "Czy mogę anulować w każdej chwili?",
            "a2": "Tak. Subskrypcję zmienisz lub anulujesz w każdej chwili w ustawieniach konta; Pro działa do końca opłaconego okresu.",
            "q3": "Jak działają zwroty?",
            "a3": "Subskrypcje cyfrowe podlegają naszej polityce zwrotów i prawom konsumenta UE. Szczegóły na stronie Zwroty.",
            "q4": "Czy jest płatność roczna?",
            "a4": "Tak. Płatność roczna daje dwa miesiące gratis względem płatności miesięcznej."
        },
        "teamCalc": {
            "title": "Idealny dla klubów i sztabu",
            "subtitle": "Team daje każdemu trenerowi osobny obszar roboczy ze wspólnymi fakturami — za ułamek kosztu osobnych subskrypcji Pro.",
            "fivePro": "5 × subskrypcji Pro",
            "teamPlan": "Plan Team",
            "savings": "Oszczędzasz {{amount}}{{period}}",
            "cta": "Wybierz Team"
        }
    },
    landing: {
        "nav": {
            "features": "Funkcje",
            "pricing": "Cennik",
            "download": "Pobierz",
            "openBoard": "Otwórz tablicę"
        },
        "hero": {
            "titlePre": "Narysuj dowolną taktykę w ",
            "titleHighlight": "30 sekund",
            "subtitle": "Błyskawiczna tablica taktyczna dla trenerów, analityków i twórców. Otwierasz w przeglądarce i rysujesz — bez instalacji i bez logowania.",
            "trustLine": "Bez konta · Za darmo · Działa w przeglądarce",
            "ctaPrimary": "Otwórz tablicę — bez rejestracji",
            "ctaSecondary": "Zobacz plany",
            "demoAlt": "Animacja tworzenia taktyki",
            "badge": "Działa w przeglądarce — bez instalacji"
        },
        "credibility": {
            "title": "Wszystko, czego trzeba — od razu",
            "item1Metric": "30 s",
            "item1Label": "do pierwszej gotowej taktyki",
            "item2Metric": "4 formaty",
            "item2Label": "eksport PNG · GIF · PDF · SVG",
            "item3Metric": "0 zł",
            "item3Label": "start bez konta i karty"
        },
        "how": {
            "title": "Od pomysłu do taktyki w 30 sekund",
            "s1Title": "Wybierz ustawienie",
            "s1Desc": "Naciśnij 1–6, aby od razu ustawić całą formację na boisku.",
            "s2Title": "Dodaj ruch",
            "s2Desc": "Rysuj podania i biegi klawiszami A i R, prosto z klawiatury.",
            "s3Title": "Eksportuj i udostępnij",
            "s3Desc": "Wciśnij Cmd+E po obraz albo wyeksportuj animowany GIF lub PDF."
        },
        "pillars": {
            "title": "Stworzone do szybkości",
            "speedTitle": "Szybko",
            "speedDesc": "Od pustego boiska do gotowej taktyki szybciej, niż zaparzysz kawę.",
            "stepsTitle": "Minimum kroków",
            "stepsDesc": "Bez grzebania w menu. Skrót na wszystko i paleta poleceń.",
            "everywhereTitle": "Bez instalacji",
            "everywhereDesc": "Działa w każdej nowoczesnej przeglądarce — Chrome, Safari, Firefox, Edge. Nic nie pobierasz.",
            "shareTitle": "Gotowe do udostępnienia",
            "shareDesc": "Eksport PNG, GIF, PDF lub SVG jednym skrótem."
        },
        "workflow": {
            "eyebrow": "Jedna biblioteka trenera",
            "title": "Od pomysłu na boisku do gotowego konspektu",
            "desc": "Nie kończ na obrazku. Zachowaj grafikę, opisz z niej ćwiczenie i dodaj je do kompletnej jednostki treningowej z czasem, kadrą, sztabem oraz materiałami.",
            "graphicTitle": "1. Grafika",
            "graphicDesc": "Narysuj ustawienie, ruch i kluczowe strefy na szybkiej tablicy taktycznej.",
            "exerciseTitle": "2. Ćwiczenie",
            "exerciseDesc": "Dodaj cel, organizację, czas, liczbę zawodników, coaching points i progresję.",
            "sessionTitle": "3. Konspekt",
            "sessionDesc": "Ułóż kolejność ćwiczeń, zadania sztabu i kadrę, a potem pobierz PDF lub wydrukuj.",
            "presetTitle": "4. Presety składu",
            "presetDesc": "Zapisuj Low block, Mid block i pressing. Wczytuj je z ławki jednym wyborem lub skrótem Option/Alt+1–9.",
            "cta": "Zacznij tworzyć trening"
        },
        "keyboard": {
            "title": "Najpierw klawiatura, mysz opcjonalnie",
            "desc": "Każda akcja ma skrót, więc ręce nie schodzą z klawiszy.",
            "palette": "Naciśnij Cmd+K, aby otworzyć paletę poleceń."
        },
        "everywhere": {
            "title": "Na każdym urządzeniu",
            "desc": "Używaj TMC Studio w przeglądarce lub zainstaluj aplikację na macOS i Windows. Wszystko synchronizuje się przez Twoje konto.",
            "cta": "Otwórz tablicę"
        },
        "useCases": {
            "title": "Pod Twój sposób pracy",
            "coachesTitle": "Trenerzy i analitycy",
            "coachesDesc": "Przygotuj treningi i odprawy meczowe, potem wydrukuj lub wyeksportuj do PDF.",
            "creatorsTitle": "Twórcy treści",
            "creatorsDesc": "Zamień pomysły w animowane GIF-y w niecałą minutę.",
            "clubsTitle": "Kluby i sztab",
            "clubsDesc": "Eksportuj odprawy do PDF i rozdaj całemu sztabowi — jeden spójny plan dla wszystkich."
        },
        "pricingTeaser": {
            "title": "Darmowy zostaje darmowy na zawsze",
            "desc": "Zacznij za darmo, bez konta. Przejdź na Pro, gdy potrzebujesz nielimitowanych projektów i eksportu GIF/PDF.",
            "cta": "Porównaj plany",
            "free": "Darmowy",
            "pro": "Pro"
        },
        "spotlight": {
            "title": "Stworzone do Twojego sposobu pracy",
            "kbTitle": "Najpierw klawiatura. Wszystko ma skrót.",
            "kbDesc": "Naciśnij Cmd+K, by otworzyć paletę poleceń, albo A dla strzałek, P dla zawodników, N dla nowych kroków. Ręce nie schodzą z klawiatury — przeciągaj, zmieniaj rozmiar i edytuj bez sięgania po mysz.",
            "stepsTitle": "Eksportuj punkty do omówienia, nie zrzuty ekranu.",
            "stepsDesc": "Buduj taktyki krok po kroku, a potem wyeksportuj całą sekwencję jako animowany GIF lub wielostronicowy PDF. Trenerzy używają tego do odpraw, twórcy zamieniają w content social media.",
            "syncTitle": "Otwierasz linkiem. Rysujesz od razu.",
            "syncDesc": "Bez instalacji i bez konta na start. Tryb Gość pozwala rysować natychmiast, a darmowe konto zapisuje Twoje projekty w chmurze."
        },
        "faq": {
            "title": "Najczęściej zadawane pytania",
            "q1": "Czy to naprawdę darmowe?",
            "a1": "Tak. Tryb Gość nie wymaga konta ani karty kredytowej. Darmowe konto daje po 3 grafiki, ćwiczenia i konspekty z synchronizacją w chmurze — bez okresu próbnego.",
            "q2": "Co mogę zrobić jako Gość?",
            "a2": "Zacznij rysować od razu — bez konta, bez rejestracji. Dostajesz 1 projekt z 5 krokami i eksportem PNG. Gotowy zapisywać? Załóż darmowe konto jednym kliknięciem.",
            "q3": "Czy muszę coś pobierać?",
            "a3": "Nie. TMC Studio działa w każdej nowoczesnej przeglądarce — Chrome, Safari, Firefox, Edge. Otwierasz i rysujesz, bez pobierania.",
            "q4": "Jakie formaty eksportu są dostępne?",
            "a4": "Gość i Free eksportują PNG i JPG. Pro dodaje GIF, PDF planszy oraz osobne PDF-y ćwiczeń i konspektów treningowych.",
            "q5": "Jak działa rozliczenie Pro?",
            "a5": "Pro kosztuje 9 USD/miesiąc lub 90 USD/rok (oszczędzasz 17%). Anuluj w każdej chwili — dostęp trwa do końca opłaconego okresu. Ceny dla klientów UE zawierają VAT.",
            "q6": "Czy cały sztab może używać Team?",
            "a6": "Tak. Team daje 5 miejsc z indywidualnymi obszarami roboczymi i wspólnym billingiem. Każdy trener zarządza własnymi tablicami, a Ty dostajesz jedną fakturę. 99 zł miesięcznie.",
            "q7": "Czy mogę zapisać kilka ustawień drużyny?",
            "a7": "Tak. Zapisz do 50 nazwanych presetów, np. Low block lub Pressing 4-3-3. Wczytasz je z ławki jednym wyborem albo skrótem Option/Alt+1–9 i od razu edytujesz na boisku.",
            "q8": "Czy TMC Studio tworzy całe konspekty treningowe?",
            "a8": "Tak. Połącz grafikę z opisem ćwiczenia, seriami i przerwami, a następnie ułóż jednostkę z kadrą, sztabem i kolejnością ćwiczeń. Gotowy konspekt wydrukujesz lub pobierzesz jako PDF."
        },
        "finalCta": {
            "title": "Zacznij rysować w 30 sekund.",
            "desc": "Bez konta, bez pobierania, bez karty kredytowej. Tylko Ty i boisko.",
            "cta": "Otwórz tablicę — bez rejestracji"
        },
        "footer": {
            "tagline": "Szybka, profesjonalna tablica taktyczna.",
            "rights": "Wszelkie prawa zastrzeżone.",
            "legalNotice": "Nota prawna",
            "refunds": "Zwroty",
            "accessibility": "Dostępność"
        }
    },
    changelog: { title: 'Co nowego', description: 'Czytelna historia tego, jak rozwijamy TMC Studio razem ze społecznością trenerów.', current: 'Aktualna wersja produktu: {{version}}', sections: { new: 'Nowości', improved: 'Usprawnienia', fixed: 'Naprawione' }, releases: {
            v013: { summary: 'To wydanie domyka codzienny warsztat trenera: szybkie ustawienia drużyny, pełne przejście od grafiki do konspektu oraz prostsze zgłaszanie problemów.', lineups: 'Nazwane presety składu z szybkim wyborem i skrótami dopasowanymi do macOS oraz Windows.', feedback: 'Publiczny changelog i formularz zgłoszeń, dzięki którym społeczność widzi postęp i może wpływać na produkt.', library: 'Uporządkowaliśmy pracę Grafika → Ćwiczenie → Konspekt, dodając podglądy, interwały i eksport PDF.', responsive: 'Ławka, menu presetów, biblioteka i panele robocze lepiej mieszczą się na mniejszych ekranach.', returnFlow: 'Edycja składu wraca dokładnie tam, skąd została rozpoczęta: do ustawień albo bezpośrednio na tablicę.', presetMenu: 'Menu szybkiej edycji ustawienia nie wychodzi już poza obszar roboczy.' },
            v012: { summary: 'Skupiliśmy się na planowaniu treningu i pracy z większą kadrą, aby mniej czasu tracić na powtarzalne wprowadzanie danych.', sessions: 'Dodaliśmy konspekty z domyślną datą, nazwą i wyborem kadry.', intervals: 'Ćwiczenia obsługują serie, czas pracy oraz długość przerw.', bulk: 'Biblioteka pozwala zaznaczać i usuwać wiele projektów oraz szybciej porządkować materiały.', roster: 'Import obsługuje do 35 zawodników na drużynę i zachowuje powtarzające się numery.', pdf: 'Poprawiliśmy pusty eksport PDF ćwiczeń i całych jednostek treningowych.', navigation: 'Powrót z edytora prowadzi teraz do właściwego widoku biblioteki.' },
            v011: { summary: 'Pierwszy duży krok od samej tablicy taktycznej do kompletnego środowiska przygotowania materiałów treningowych.', workflow: 'Uruchomiliśmy osobną bibliotekę grafik, ćwiczeń i konspektów.', seo: 'Dodaliśmy wielojęzyczne, indeksowalne strony produktowe.', oauth: 'Ustabilizowaliśmy logowanie Google przez bezpieczny przepływ PKCE.', pdf: 'Naprawiliśmy druk i eksport pierwszych widoków ćwiczeń oraz konspektów.', authCallback: 'Usunęliśmy zawieszanie ekranu po powrocie z autoryzacji Google.' }
        } },
    bugReport: { title: 'Zgłoś błąd', description: 'Opisz problem w TMC Studio i pomóż nam poprawić produkt.', community: 'TMC Studio rozwija się razem ze społecznością trenerów. Każde konkretne zgłoszenie pomaga nam szybciej poprawiać produkt dla wszystkich.', titleLabel: 'Krótki tytuł problemu', descriptionLabel: 'Co się wydarzyło?', stepsLabel: 'Jak odtworzyć problem?', expectedLabel: 'Jak powinno to działać?', emailLabel: 'E-mail do odpowiedzi (opcjonalnie)', submit: 'Wyślij zgłoszenie', sending: 'Wysyłanie…', sentTitle: 'Dziękujemy za zgłoszenie', sentBody: 'Zgłoszenie dotarło do zespołu TMC Studio. Dzięki Tobie produkt będzie lepszy.', error: 'Nie udało się wysłać zgłoszenia. Spróbuj ponownie lub napisz na support@tacticsmadeclear.store.' },
    common: {
        close: 'Zamknij',
        saving: 'Zapisywanie…',
        loading: 'Wczytywanie…',
        language: 'Język',
        settings: 'Ustawienia',
    },
    topbar: {
        pitch: 'Boisko',
        pitchTitle: 'Ustawienia boiska',
        export: 'Eksport',
        focusMode: 'Tryb skupienia',
        themeToDark: 'Tryb ciemny',
        themeToLight: 'Tryb jasny',
        help: 'Pomoc i skróty',
        commandPalette: 'Paleta poleceń',
        openProjects: 'Otwórz projekty',
        projectName: 'Nazwa projektu',
        clickRename: 'Kliknij, aby zmienić nazwę',
        offline: 'Offline',
        saving: 'Zapisywanie…',
        saved: 'Zapisano',
        unsaved: 'Niezapisane',
        players: 'Zawodnicy',
        addPlayers: 'Dodaj zawodników',
        arrows: 'Strzałki',
        showArrows: 'Pokaż strzałki',
        zones: 'Strefy',
        showZones: 'Pokaż strefy',
        equipment: 'Sprzęt',
        showEquipment: 'Pokaż sprzęt',
        exportBoard: 'Eksportuj planszę',
        presetSquad: 'Przygotuj skład',
        squadHint: 'Łatwe przeciąganie na boisko',
        rectangleZone: 'Strefa prostokątna',
        polygonZone: 'Strefa wielokątna',
        tallCone: 'Wysoki pachołek',
        ballCluster: 'Grupa piłek',
        exportPngCurrent: 'PNG — bieżący krok',
        exportPngAll: 'PNG — wszystkie kroki',
        exportJpgCurrent: 'JPG — bieżący krok',
        exportPdfAll: 'PDF — wszystkie kroki',
        exportGif: 'Animowany GIF',
        proMarked: 'Funkcje Pro oznaczono ⭐',
        account: 'Konto',
        planPro: 'Pro',
        planFree: 'Free',
        accountBilling: 'Konto i płatności',
        accountEditorOptions: 'Opcje edytora',
        accountPitchSettings: 'Ustawienia boiska',
        accountSquadSettings: 'Ustawienia drużyny',
        accountYourProfile: 'Twój profil',
        signInToSave: 'Zaloguj się — zapisuj projekty za darmo',
        signInToSaveDesc: 'Założ darmowe konto, by zapisywać, synchronizować i zarządzać swoimi tablicami na wszystkich urządzeniach.',
        upgradePro: 'Przejdź na Pro',
        devTestLogin: 'Dev test login',
        devGuest: 'Guest',
        devFree: 'Bez Premium',
        devSolo: 'Solo',
        devTeam: 'Team',
        clearDevData: 'Wyczyść dane testowe',
        logOut: 'Wyloguj',
        toggleInspector: 'Przełącz inspektor',
        signIn: 'Zaloguj się',
        signInDescription: 'Zaloguj się, by zapisywać i synchronizować tablice',
    },
    contextMenu: {
        header: {
            player: 'Zawodnik #{{number}} ({{team}})',
            zone: 'Strefa ({{shape}})',
            text: 'Tekst: "{{preview}}"',
            arrow: 'Strzałka {{type}}',
            ball: 'Piłka',
            equipment: '{{type}}',
        },
        arrow: {
            pass: 'Podanie',
            run: 'Bieg',
            shoot: 'Strzał',
            dribble: 'Drybling',
        },
        shape: {
            rectangle: 'Prostokąt',
            ellipse: 'Elipsa',
            polygon: 'Wielokąt',
        },
        selectedCount: 'Zaznaczono {{count}} elementów',
        groupSelected: 'Grupuj zaznaczone',
        ungroup: 'Rozgrupuj',
        lockElement: 'Zablokuj element',
        unlockElement: 'Odblokuj element',
        lockSelected: 'Zablokuj zaznaczone',
        unlockSelected: 'Odblokuj zaznaczone',
        copy: 'Kopiuj',
        paste: 'Wklej',
        selectAll: 'Zaznacz wszystko',
        duplicate: 'Duplikuj',
        delete: 'Usuń',
        resize: 'Zmień rozmiar…',
        addPlayerTeam1: 'Dodaj zawodnika Drużyna 1',
        addPlayerTeam2: 'Dodaj zawodnika Drużyna 2',
        addPlayerTeam3: 'Dodaj zawodnika Drużyna 3',
        addPlayerTeam4: 'Dodaj zawodnika Drużyna 4',
        addBall: 'Dodaj piłkę',
        addArrow: 'Dodaj strzałkę',
        addZone: 'Dodaj strefę',
        autoNumberingOn: 'Auto-numeracja: WŁ.',
        autoNumberingOff: 'Auto-numeracja: WYŁ.',
        changeNumber: 'Zmień numer',
        renumberArrows: 'Przenumeruj od 1',
        switchTeam: 'Zmień drużynę',
        cycleShape: 'Zmień kształt',
        changeColor: 'Zmień kolor',
        editText: 'Edytuj tekst',
        alignLeft: 'Wyrównaj do lewej',
        alignCenter: 'Wyśrodkuj',
        alignRight: 'Wyrównaj do prawej',
        alignJustify: 'Wyjustuj',
        editArrowNumber: 'Edytuj numer strzałki',
        rotate: 'Obróć',
        bringToFront: 'Na wierzch',
        bringForward: 'Przesuń do przodu',
        sendBackward: 'Przesuń do tyłu',
        sendToBack: 'Na spód',
    },
    footer: {
        label: 'Stopka',
        download: 'Pobierz aplikację',
        privacy: 'Prywatność',
        terms: 'Regulamin',
        cookies: 'Pliki cookie',
        contact: 'Kontakt',
        changelog: 'Co nowego',
        reportBug: 'Zgłoś błąd',
        hide: 'Ukryj stopkę',
        show: 'Pokaż stopkę',
        social: {
            x: 'Profil X',
            linkedin: 'Profil LinkedIn',
            github: 'Profil GitHub',
        },
    },
    legacy: {
        toolbar: {
            newBoard: 'Nowa plansza',
            new: 'Nowa',
            saveTitle: 'Zapisz (Ctrl+S)',
            save: 'Zapisz',
            load: 'Wczytaj',
            addHomePlayer: 'Dodaj zawodnika gospodarzy (P)',
            home: 'Gospodarze',
            addAwayPlayer: 'Dodaj zawodnika gości',
            away: 'Goście',
            addBall: 'Dodaj piłkę (B)',
            ball: 'Piłka',
            duplicateTitle: 'Powiel (Ctrl+D)',
            duplicate: 'Powiel',
            deleteTitle: 'Usuń (Del)',
            delete: 'Usuń',
            undo: 'Cofnij (Ctrl+Z)',
            redo: 'Ponów (Ctrl+Shift+Z)',
            hint: 'P: zawodnik | B: piłka | Ctrl+D: powiel | Ctrl+Z: cofnij',
        },
        rightPanel: {
            properties: 'Właściwości',
            none: 'Nie wybrano elementu',
            noneHint: 'Kliknij zawodnika albo piłkę, aby zobaczyć właściwości',
            selected: 'Zaznaczono elementów: {{count}}',
            multiHint: 'Tryb wielokrotnego zaznaczenia. Użyj Ctrl+D, aby powielić, albo Delete, aby usunąć.',
            type: 'Typ',
            homePlayer: 'Zawodnik gospodarzy',
            awayPlayer: 'Zawodnik gości',
            ball: 'Piłka',
            number: 'Numer',
            label: 'Etykieta (opcjonalnie)',
            labelPlaceholder: 'np. Messi',
            position: 'Pozycja',
            shortcuts: 'Skróty',
            shiftClick: 'Shift + klik = wielokrotne zaznaczenie',
            delDelete: 'Del = usuń zaznaczenie',
        },
    },
    zoom: {
        out: 'Oddal (Cmd -)',
        outAria: 'Oddal',
        in: 'Przybliż (Cmd +)',
        inAria: 'Przybliż',
        value: 'Zoom: {{percent}}%',
        unlock: 'Odblokuj widok (włącz zoom/pan)',
        lock: 'Zablokuj widok (bez zoom/pan)',
        unlockAria: 'Odblokuj viewport',
        lockAria: 'Zablokuj viewport',
        fit: 'Dopasuj',
        fitTitle: 'Dopasuj do widoku (Shift+1)',
        fitAria: 'Dopasuj do widoku',
    },
    offline: {
        message: 'Jesteś offline — zmiany zsynchronizują się po powrocie online',
    },
    textEdit: {
        hint: 'Enter = zapisz · Shift+Enter = nowa linia',
    },
    shortcutsHint: {
        press: 'Naciśnij',
        forShortcuts: 'dla skrótów',
        forCommands: 'dla komend',
    },
    bottomSheet: {
        inspectorPanel: 'Panel inspektora',
        closeInspector: 'Zamknij inspektor',
        close: 'Zamknij',
    },
    smartBottom: {
        undo: 'Cofnij (⌘Z)',
        redo: 'Ponów (⇧⌘Z)',
        resize: 'Przeciągnij, aby zmienić wysokość panelu',
        collapse: 'Zwiń panel',
        expand: 'Rozwiń panel',
        addPlayer: 'Dodaj zawodnika',
        addBall: 'Dodaj piłkę',
        drawArrow: 'Rysuj strzałkę',
        allCommands: '⌘K — wszystkie komendy',
        elements: 'Elementy: {{count}}',
        editing: 'Edycja',
    },
    inspector: {
        props: 'Właściwości',
        layers: 'Warstwy',
        identity: 'Tożsamość',
        appearance: 'Wygląd',
        labels: 'Etykiety',
        role: 'Rola',
        advanced: 'Zaawansowane',
        numbering: 'Numeracja',
        sequence: 'Sekwencja',
        number: 'Numer',
        label: 'Etykieta',
        showLabelBelow: 'Pokaż etykietę pod spodem',
        goalkeeper: 'Bramkarz',
        gkHint: 'Kolor bramkarza drużyny · Shift+G',
        labelSize: 'Rozmiar etykiety',
        opacity: 'Krycie',
        opacityAll: 'Krycie (wszystkie)',
        playerLabelPlaceholder: 'Nazwisko albo pseudonim…',
        playerLabelAria: 'Etykieta zawodnika',
        showOrientation: 'Pokaż orientację',
        showArms: 'Pokaż ramiona',
        visionCone: 'Stożek widzenia',
        zoomThreshold: 'Próg zoomu',
        showNumber: 'Pokaż numer',
        autoNumber: 'Auto-numeruj strzałki',
        renumber: 'Przenumeruj 1…N',
        showLabelBelowAria: 'Pokaż etykietę pod spodem',
        goalkeeperAria: 'Bramkarz',
        showOrientationAria: 'Pokaż orientację',
        showArmsAria: 'Pokaż ramiona',
        visionConeAria: 'Stożek widzenia',
        showNumberAria: 'Pokaż numer',
        autoNumberAria: 'Auto-numeruj strzałki',
        arrowNumberPlaceholder: 'Bez numeru',
        arrowNumberAria: 'Numer strzałki',
        renumberAria: 'Przenumeruj strzałki',
        groups: 'Grupy',
        doubleClickRename: 'Kliknij dwa razy, aby zmienić nazwę',
        unlockGroup: 'Odblokuj grupę',
        lockGroup: 'Zablokuj grupę',
        hideGroup: 'Ukryj grupę',
        showGroup: 'Pokaż grupę',
        locked: 'Blokada',
        lockToggle: 'Zablokuj element',
        lockHint: 'Zablokowany element można zaznaczyć, ale nie można go przesuwać ani skalować.',
        visionConeHint: 'V / Shift+V',
        selected: 'Zaznaczono elementów: {{count}}',
        multiHint: 'Dotyczy zaznaczonych zawodników.',
        showLabels: 'Pokaż etykiety',
        hideLabels: 'Ukryj etykiety',
        searchPlaceholder: 'Szukaj elementów…',
        noElements: 'Brak elementów',
        quickActions: 'Szybkie akcje',
        commandPalette: 'Paleta poleceń',
        closeInspector: 'Zamknij inspektor (I)',
        closeInspectorAria: 'Zamknij inspektor',
        resize: 'Przeciągnij, aby zmienić szerokość panelu',
        openInspector: 'Otwórz inspektor (I)',
        openInspectorAria: 'Otwórz inspektor',
        openInspectorPanelAria: 'Otwórz panel inspektora',
        inspectorTitle: 'Inspektor (I)',
        showCoordinates: 'Pokaż współrzędne',
        elementType: {
            player: 'Zawodnik', ball: 'Piłka', arrow: 'Strzałka', zone: 'Strefa', text: 'Tekst',
        },
        team: {
            home: 'Gospodarze', away: 'Goście', team3: 'Drużyna 3', team4: 'Drużyna 4',
        },
        setAsDefault: 'Ustaw jako domyślne', setAsDefaultHint: 'Zapisz bieżący wygląd jako domyślny dla nowych elementów', setAsDefaultDone: 'Zapisano jako domyślne',
        zone: {
            border: 'Linia graniczna', borderStyle: 'Styl', solid: 'Ciągła', dashed: 'Przerywana', none: 'Brak',
            borderWidth: 'Grubość', borderColor: 'Kolor', corners: 'Narożniki',
        },
        arrow: {
            head: 'Grot', startHead: 'Początek', endHead: 'Koniec',
            line: 'Linia', thickness: 'Grubość', color: 'Kolor',
            headArrow: 'Strzałka', headNone: 'Brak', headBar: 'Kreska', headDot: 'Kropka',
            doubleHead: 'Podwójny grot', hideHeads: 'Ukryj groty',
        },
        filters: {
            all: 'Wszystkie', home: 'Gospodarze', away: 'Goście', ball: 'Piłka',
        },
        layerNames: {
            homePlayers: 'Gospodarze', awayPlayers: 'Goście', ball: 'Piłka',
            arrows: 'Strzałki', zones: 'Strefy', labels: 'Tekst i etykiety',
            equipment: 'Sprzęt', drawings: 'Rysunki',
        },
    },
    settings: {
        account: 'Konto', club: 'Klub i członkowie', editor: 'Edytor', board: 'Plansza', general: 'Ogólne',
        profile: 'Profil', security: 'Bezpieczeństwo', billing: 'Płatności', preferences: 'Preferencje', squad: 'Skład', teams: 'Drużyny', pitch: 'Boisko', shortcuts: 'Skróty', dataPrivacy: 'Dane i prywatność', about: 'O aplikacji',
        close: 'Zamknij ustawienia', profileInfo: 'Informacje profilu', profilePhoto: 'Zdjęcie profilowe', uploading: 'Wysyłanie…', uploadPhoto: 'Prześlij nowe zdjęcie', fullName: 'Imię i nazwisko', yourName: 'Twoje imię', emailReadonly: 'Email nie może zostać zmieniony',
        saving: 'Zapisywanie…', saveChanges: 'Zapisz zmiany', changePassword: 'Zmień hasło', currentPassword: 'Aktualne hasło', currentPasswordPlaceholder: 'Wpisz aktualne hasło', newPassword: 'Nowe hasło', newPasswordPlaceholder: 'Wpisz nowe hasło (min. 8 znaków)', confirmNewPassword: 'Potwierdź nowe hasło', confirmNewPasswordPlaceholder: 'Potwierdź nowe hasło', changing: 'Zmienianie…',
        dangerZone: 'Strefa ryzyka', deleteAccount: 'Usuń konto', deleteWarning: 'Tej akcji nie można cofnąć. Usuniemy konto, projekty, pliki i klub, a subskrypcja zostanie anulowana.', typeDelete: 'Wpisz DELETE, aby potwierdzić', enterPassword: 'Wpisz hasło', yourPassword: 'Twoje hasło', deleting: 'Usuwanie…', deleteMyAccount: 'Usuń moje konto',
        currentPlan: 'Aktualny plan', plan: 'Plan', upgrade: 'Upgrade', renewsOn: 'Odnawia się {{date}}', freeNudgeTitle: 'Jesteś na Free — przejdź na Pro, aby mieć więcej', freeNudgeText: 'Odblokuj nielimitowane projekty, nielimitowane kroki, eksport GIF/PDF i priorytetowe wsparcie', upgradeProArrow: 'Przejdź na Pro →', manageSubscription: 'Zarządzaj subskrypcją', openBillingPortal: 'Otwórz portal płatności', billingPortalHint: 'Zmień metodę płatności, zobacz faktury albo anuluj subskrypcję',
        appearance: 'Wygląd', theme: 'Motyw', light: 'Jasny', dark: 'Ciemny', system: 'Systemowy', showGrid: 'Pokaż siatkę', showGridHint: 'Wyświetl siatkę wyrównania na planszy', snapGrid: 'Przyciągaj do siatki', snapGridHint: 'Automatycznie wyrównuj elementy do siatki', gridDensity: 'Gęstość siatki', gridDensityHint: 'Steruje odstępami widocznej siatki i przyciągania nowych lub przesuwanych elementów.', pixelsValue: '{{value}}px', editorDefaults: 'Domyślne ustawienia edytora', defaultArrow: 'Domyślna strzałka', defaultArrowHint: 'Używana przez ogólne przyciski Dodaj strzałkę w pustym stanie i szybkich paskach.', arrowPass: 'Podanie', arrowRun: 'Bieg', arrowShoot: 'Strzał', arrowDribble: 'Drybling', defaultStepDuration: 'Domyślny czas kroku', defaultStepDurationHint: 'Używany do tempa odtwarzania i eksportu animacji.', secondsValue: '{{value}}s', styleDefaults: 'Domyślne style elementów', resetDefaults: 'Przywróć domyślne', arrowDefaults: 'Strzałki', zoneDefaults: 'Strefy', zoneFill: 'Wypełnienie', zoneOpacity: 'Krycie', preferencesHint: 'Preferencje są synchronizowane między urządzeniami przez chmurę.', coachingProfile: 'Profil trenerski', coachingProfileHint: 'Dane klubu i sztabu używane w konspektach.', clubLogo: 'Logo klubu', changeLogo: 'Zmień logo', clubName: 'Nazwa klubu', clubNamePlaceholder: 'np. TMC Academy', logoHint: 'Logo pojawi się w konspektach. PNG, JPG lub WebP do 1 MB.', staffPresets: 'Twój sztab', staffPresetsHint: 'Dodawaj osoby do konspektu jednym kliknięciem.', staffRoleFallback: 'Sztab', removeStaff: 'Usuń {{name}} ze sztabu', staffName: 'Imię i nazwisko', staffRole: 'Rola, np. asystent', addStaff: 'Dodaj', sessionDefaults: 'Domyślna nowa jednostka', sessionDefaultsHint: 'Ustaw raz datę, nazwę i miejsce używane przy tworzeniu kolejnych konspektów.', sessionDateOffset: 'Dni od dzisiaj', sessionNameTemplate: 'Wzór nazwy', sessionNameTemplatePlaceholder: 'Trening - {date}', sessionVenue: 'Miejsce', sessionStartTime: 'Godzina', sessionMicrocycleDay: 'Dzień mikrocyklu', positionGroups: 'Grupy zawodników', positionGroupsHint: 'Przypisz skład do grup, które będą automatycznie dodawane do jednostki.', positionGroupPlaceholder: 'np. Pomocnicy', addPositionGroup: 'Dodaj grupę', removePositionGroup: 'Usuń grupę {{name}}', positionGroupsEmptySquad: 'Najpierw dodaj zawodników w zakładce Skład.', teamColors: 'Kolory drużyn',
        squadRoster: 'Lista składu', playersCount: '{{count}}/{{max}} zawodników', showOnBoard: 'Pokaż na planszy', showSquadOnBoard: 'Pokaż skład na planszy', proFeature: 'Funkcja Pro', squadFreeHint: 'Plan Free pozwala na 5 zawodników w składzie. Pro i Club Premium pozwalają na 35 na drużynę (maks. 140).', squadFull: 'Wybrana drużyna jest pełna. Limit Pro i Club Premium to 35 zawodników na drużynę.', name: 'Imię', playerName: 'Imię zawodnika', numberShort: '#', numberPlaceholder: 'Nr', team: 'Drużyna', add: 'Dodaj', addMany: 'Dodaj wielu', addPlayers: 'Dodaj zawodników', bulkPlayersLabel: 'Wklej listę zawodników', bulkPlayersPlaceholder: '1 Jan Kowalski\n7, Piotr Nowak\nAdam Zieliński', bulkPlayersHint: 'Jeden zawodnik w wierszu. Podane numery, także powtórzone, zostaną zachowane; bez numeru zostanie nadany pierwszy wolny.', bulkNoValidPlayers: 'Nie znaleziono poprawnych zawodników do dodania.', bulkSkippedLines: 'Pominięto wiersze z błędną nazwą lub numerem: {{lines}}', editPlayerName: 'Zmień nazwę zawodnika {{name}}', editPlayerNumber: 'Zmień numer zawodnika {{name}}', editPlayerTeam: 'Zmień drużynę zawodnika {{name}}', noPlayers: 'Nie zdefiniowano jeszcze zawodników. Dodaj skład powyżej.', removePlayer: 'Usuń {{name}}', squadTip: 'Zmiany składu zapisują się automatycznie. Włącz „Pokaż na planszy”, aby przeciągać zawodników z ławki na boisko.',
        languageHint: 'Wybierz język aplikacji.', keyboardShortcuts: 'Skróty klawiszowe', shortcutCustomizationHint: 'Skróty są pogrupowane według pracy w edytorze. Pro i Club Pro mogą kliknąć skrót i nagrać własną kombinację.', resetShortcuts: 'Reset do fabrycznych', shortcutResetSuccess: 'Skróty przywrócone do układu fabrycznego.', shortcutPressKeys: 'Naciśnij skrót', shortcutSaved: 'Skrót zapisany: {{shortcut}}', shortcutDuplicate: 'Skrót {{shortcut}} jest już przypisany do: {{action}}', shortcutProOnly: 'Edycja skrótów jest dostępna w Pro i Club Pro.', editShortcutAria: 'Edytuj skrót: {{action}}', aboutVersion: 'Wersja {{version}} — Tactics Made Clear', aboutBy: 'by Sportpredictor', contact: 'Kontakt', reportBug: 'Zgłoś błąd', sendFeedback: 'Wyślij feedback', contactFounder: 'Krystian Rubajczyk', contactFounderHint: 'Kontakt produktowy i szybkie zgłoszenia przez e-mail albo X.', legalPrivacy: 'Prywatność', legalTerms: 'Regulamin', legalCookies: 'Cookies', legalInfo: 'Informacje prawne', rights: 'Wszelkie prawa zastrzeżone.', dataHint: 'Wyeksportuj planszę do pliku albo zaimportuj wcześniej zapisany plik.', exportBoard: 'Eksportuj planszę (.json)', importBoard: 'Importuj planszę', importSuccess: 'Plansza zaimportowana.', importInvalid: 'Nieprawidłowy plik planszy.', manualSaveSuccess: 'Projekt zapisany.', manualSaveError: 'Nie udało się zapisać projektu w chmurze. Spróbuj ponownie.', importWarning: 'Import zastępuje bieżącą planszę — najpierw zrób eksport, jeśli chcesz ją zachować.',
        errors: { nameRequired: 'Imię jest wymagane', profileFailed: 'Nie udało się zaktualizować profilu', passwordFields: 'Uzupełnij wszystkie pola hasła', passwordLength: 'Nowe hasło musi mieć co najmniej 8 znaków', passwordsMismatch: 'Hasła nie są takie same', passwordFailed: 'Nie udało się zmienić hasła', typeDelete: 'Wpisz DELETE, aby potwierdzić', passwordRequired: 'Hasło jest wymagane', deleteFailed: 'Nie udało się usunąć konta', ownsClubWithMembers: 'Jesteś właścicielem klubu z innymi członkami. Najpierw przekaż własność albo usuń członków, potem usuń konto.', imageFile: 'Wybierz plik obrazu', imageSize: 'Obraz musi mieć mniej niż 2 MB', avatarFailed: 'Nie udało się przesłać avatara' },
        success: { profile: 'Profil zaktualizowany!', password: 'Hasło zmienione!', avatar: 'Avatar zaktualizowany!' },
        shortcutGroups: { create: 'Tworzenie elementów', players: 'Zawodnicy i orientacja', selection: 'Zaznaczenie', workflow: 'Workflow' },
        shortcutItems: { players: 'Dodaj zawodnika gospodarzy / gości', playersHome: 'Dodaj zawodnika gospodarzy', playersAway: 'Dodaj zawodnika gości', ball: 'Dodaj piłkę', arrows: 'Strzałka podania / biegu / strzału / dryblingu', passArrow: 'Strzałka podania', runArrow: 'Strzałka biegu', shootArrow: 'Strzałka strzału', dribbleArrow: 'Strzałka dryblingu', zones: 'Strefa prostokątna / elipsa', zoneRect: 'Strefa prostokątna', zoneEllipse: 'Strefa elipsa', text: 'Etykieta tekstowa', equipment: 'Pachołek / obręcz', cone: 'Pachołek', hoop: 'Obręcz', goalkeeper: 'Ustaw bramkarza / cykl koloru GK', vision: 'Włącz wizję zaznaczonym zawodnikom', orientationHandles: 'Przełącz rączki orientacji zawodników', resetOrientation: 'Wyzeruj orientację zaznaczonych', formations: 'Zastosuj formację gospodarzy / gości', focus: 'Tryb skupienia', fullShortcuts: 'Otwórz pełne skróty', resizeUp: 'Powiększ zaznaczone elementy', resizeDown: 'Zmniejsz zaznaczone elementy' },
        savedLineups: 'Biblioteka ustawień taktycznych', savedLineupsHint: 'Ustaw zawodników na boisku, nazwij organizację i przypisz wybranym ustawieniom skróty {{shortcuts}}.', lineupNamePlaceholder: 'np. Low block, Mid block, Pressing 4-3-3', lineupTeam: 'Drużyna ustawienia', saveCurrentLineup: 'Zapisz aktualne pozycje', noSavedLineups: 'Nie masz jeszcze zapisanych ustawień. Ustaw zawodników na boisku i zapisz pierwszy wariant.', lineupPlayersCount: '{{count}} zawodników', lineupShortcut: 'Skrót dla {{name}}', noLineupShortcut: 'Bez skrótu', saveName: 'Zapisz', editOnBoard: 'Edytuj na boisku', overwriteLineup: 'Nadpisz pozycje', renameLineup: 'Zmień nazwę', removeLineup: 'Usuń', editingLineup: 'Edytujesz ustawienie', editingLineupHint: 'Przesuń zawodników na boisku, a następnie zapisz zmiany.', saveLineupChanges: 'Zapisz zmiany', cancelLineupEdit: 'Anuluj', lineupChangesSaved: 'Zapisano zmiany ustawienia {{name}}.', lineupEditCancelled: 'Anulowano edycję ustawienia.', emptySlot: 'Pusty slot', saveTeam1: 'Zapisz D1', saveTeam2: 'Zapisz D2', applyLineup: 'Wczytaj', lineupSaved: 'Zapisano ustawienie {{slot}}.', lineupApplied: 'Wczytano ustawienie {{slot}}.', lineupNeedsPlayers: 'Najpierw ustaw zawodników wybranej drużyny na boisku.', lineupEmpty: 'To ustawienie jest puste.',
    },
    emptyState: {
        title: 'Zacznij planszę',
        subtitle: 'Dodaj elementy, aby rozpocząć tworzenie planszy taktycznej',
        addPlayer: 'Dodaj zawodnika',
        addPlayerHint: 'Umieść zawodnika na boisku',
        addBall: 'Dodaj piłkę',
        addBallHint: 'Umieść piłkę na boisku',
        addArrow: 'Dodaj strzałkę',
        addArrowHint: 'Narysuj podanie albo bieg',
        commandPalette: 'Paleta poleceń',
    },
    auth: {
        continueFree: 'Kontynuuj za darmo',
        resetPassword: 'Reset hasła',
        signInSubtitle: 'Zaloguj się, aby zapisywać pracę i odblokować plan Free.',
        resetSubtitle: 'Wpisz email, aby zresetować hasło',
        requiredFields: 'Uzupełnij wszystkie wymagane pola',
        passwordsMismatch: 'Hasła nie są takie same',
        passwordTooShort: 'Hasło musi mieć co najmniej 8 znaków',
        verifyEmail: 'Konto utworzone. Otwórz wysłany link potwierdzający. Jeśli go nie ma, sprawdź spam.',
        devLogin: 'Dev test login (pomija auth)',
        freeTier: 'Bez Premium',
        proTier: 'Solo Premium',
        teamTier: 'Team Premium',
        continueGoogle: 'Kontynuuj z Google',
        googlePopupTitle: 'Logowanie przez Google',
        googlePopupDescription: 'Dokończ logowanie w otwartym oknie. Możesz dalej pracować w TMC Studio.',
        googleProgressTitle: 'Dokończ logowanie w Google',
        googleProgressDescription: 'Okno Google jest otwarte. Po zatwierdzeniu dostępu TMC Studio wróci tutaj automatycznie.',
        googleProgressWaiting: 'Czekamy na Google...',
        popupRecoverySuccessTitle: 'Logowanie zakończone w tym oknie',
        popupRecoveryErrorTitle: 'Nie udało się zakończyć logowania',
        popupRecoveryDescription: 'Wróć do głównego okna TMC Studio. Jeśli się nie zaktualizowało, zamknij to okno i spróbuj ponownie.',
        popupRecoveryClose: 'Zamknij okno',
        or: 'lub',
        fullName: 'Imię i nazwisko',
        fullNamePlaceholder: 'Jan Kowalski',
        email: 'Email',
        emailPlaceholder: 'ty@example.com',
        password: 'Hasło',
        confirmPassword: 'Potwierdź hasło',
        forgotPassword: 'Nie pamiętasz hasła?',
        loading: 'Ładowanie…',
        signIn: 'Zaloguj',
        createAccount: 'Utwórz konto',
        sendResetLink: 'Wyślij link resetujący',
        noAccount: 'Nie masz konta?',
        signUp: 'Zarejestruj się',
        alreadyAccount: 'Masz już konto?',
        backToSignIn: 'Wróć do logowania',
        freeForever: 'Free zostaje darmowy na zawsze. Bez karty.',
        errorInitFailed: 'Nie udało się zainicjować logowania',
        errorOfflineMode: 'Logowanie nie jest dostępne w trybie offline',
        resetEmailSent: 'Wysłaliśmy link do resetu hasła. Sprawdź skrzynkę odbiorczą i spam.',
        errorEmailNotConfirmed: 'Potwierdź email przed zalogowaniem. Sprawdź skrzynkę.',
        emailNotConfirmed: 'Twój email nie został jeszcze potwierdzony. Sprawdź skrzynkę na link potwierdzający.',
        resendConfirmation: 'Wyślij ponownie email potwierdzający',
        confirmationResent: 'Wysłaliśmy nowy link potwierdzający. Sprawdź skrzynkę odbiorczą i spam.',
        newPassword: 'Nowe hasło',
        confirmNewPassword: 'Potwierdź nowe hasło',
        resetPasswordTitle: 'Reset hasła',
        resetPasswordSubtitle: 'Wpisz nowe hasło',
        resetPasswordSuccess: 'Hasło zostało zresetowane. Przekierowuję do aplikacji…',
        resetPasswordVerifying: 'Weryfikacja linku resetującego…',
        resetPasswordInvalid: 'Link resetujący hasło jest nieprawidłowy lub wygasł. Poproś o nowy.',
        resetPasswordEnterNew: 'Wpisz nowe hasło',
        resetPasswordButton: 'Resetuj hasło',
        resettingPassword: 'Resetowanie…',
        resetPasswordBackHome: '← Powrót do strony głównej',
        authNotConfigured: 'Uwierzytelnianie nie jest skonfigurowane',
        resetFailed: 'Nie udało się zresetować hasła',
        callbackLoading: 'Logowanie…',
        callbackTimeout: 'Logowanie trwało zbyt długo. Spróbuj ponownie.',
        callbackUnavailable: 'Logowanie nie jest obecnie dostępne.',
        callbackSessionFailed: 'Nie udało się utworzyć sesji. Spróbuj ponownie.',
        callbackFailed: 'Nie udało się zalogować. Spróbuj ponownie.',
        callbackErrorTitle: 'Nie udało się zalogować',
        callbackErrorDescription: 'Nie mogliśmy dokończyć logowania.',
        callbackBack: 'Wróć do TMC Studio',
    },
    confirm: {
        confirm: 'Potwierdź',
        cancel: 'Anuluj',
        processing: 'Przetwarzanie…',
    },
    exportToast: {
        canvasNotReady: 'Canvas nie jest gotowy',
        pngExported: 'PNG wyeksportowany.',
        exportingSteps: 'Eksport kroków: {{count}}…',
        exportedPngs: 'Wyeksportowano PNG: {{count}}.',
        gifPro: 'Eksport GIF jest funkcją Pro',
        gifNeedSteps: 'GIF wymaga co najmniej 2 kroków',
        gifCreating: 'Tworzenie GIF…',
        gifEncoding: 'Kodowanie GIF…',
        gifExported: 'GIF wyeksportowany.',
        gifFailed: 'Eksport GIF nieudany',
        pdfPro: 'Eksport PDF jest funkcją Pro',
        pdfCreating: 'Tworzenie PDF…',
        pdfExported: 'PDF wyeksportowany.',
        pdfFailed: 'Eksport PDF nieudany',
        svgExported: 'SVG wyeksportowany.',
        svgFailed: 'Eksport SVG nieudany',
        jpgExported: 'JPG wyeksportowany.',
    },
    billingToast: {
        signInFirst: 'Najpierw się zaloguj',
        portalFailed: 'Nie udało się otworzyć portalu płatności',
    },
    settingsToast: {
        profileUpdated: 'Profil zaktualizowany',
        passwordChanged: 'Hasło zmienione',
        accountDeleted: 'Konto usunięte. Do zobaczenia.',
    },
    projectToast: {
        loaded: 'Projekt wczytany',
        loadFailed: 'Nie udało się wczytać projektu',
        limitFree: 'Masz {{count}}/3 elementy tego rodzaju. Przejdź na Pro, aby mieć bez limitu.',
        created: 'Utworzono nowy projekt',
        savedCloud: 'Projekt zapisany w chmurze',
        saveCloudFailed: 'Nie udało się zapisać w chmurze',
        cloudSaveError: 'Błąd zapisu w chmurze. Sprawdź konsolę.',
        deleted: 'Projekt usunięty',
        deletedMany: 'Usunięto {{count}} projektów',
        deletedManyPartial: 'Usunięto {{count}} z {{total}} projektów',
        deleteFailed: 'Nie udało się usunąć projektu',
        duplicated: 'Projekt powielony',
        renamed: 'Projekt przemianowany',
        refreshed: 'Odświeżono projekty',
        graphicAttached: 'Grafika „{{name}}” została dodana do ćwiczenia',
        folderCreated: 'Folder „{{name}}” utworzony',
        folderCreateFailed: 'Nie udało się utworzyć folderu',
        folderUpdated: 'Folder „{{name}}” zaktualizowany',
        folderUpdateFailed: 'Nie udało się zaktualizować folderu',
        deleteFolderTitle: 'Usunąć folder?',
        deleteFolderDescription: 'To usunie folder i wszystkie podfoldery w środku. Projekty nie zostaną usunięte — zostaną w Twojej przestrzeni roboczej.',
        deleteFolderConfirm: 'Usuń folder',
        folderDeleted: 'Folder usunięty',
        folderDeleteFailed: 'Nie udało się usunąć folderu',
        favoriteAdded: 'Dodano do ulubionych',
        favoriteRemoved: 'Usunięto z ulubionych',
        favoriteFailed: 'Nie udało się zaktualizować ulubionych',
        movedToFolder: 'Projekt przeniesiony do folderu',
        removedFromFolder: 'Projekt usunięty z folderu',
        moveProjectFailed: 'Nie udało się przenieść projektu',
        tagsFailed: 'Nie udało się zapisać tagów',
        projectPinned: 'Projekt przypięty',
        projectUnpinned: 'Projekt odpięty',
        pinProjectFailed: 'Nie udało się zaktualizować przypięcia',
        folderPinned: 'Folder przypięty',
        folderUnpinned: 'Folder odpięty',
        pinFolderFailed: 'Nie udało się zaktualizować przypięcia folderu',
        renameProjectFailed: 'Nie udało się zmienić nazwy projektu',
        folderMoved: 'Folder przeniesiony',
        folderMoveFailed: 'Nie udało się przenieść folderu',
        folderRenamed: 'Folder przemianowany',
        renameFolderFailed: 'Nie udało się zmienić nazwy folderu',
    },
    limits: {
        guestTitle: 'Osiągnięto limit trybu Guest',
        freeTitle: 'Osiągnięto limit planu Free',
        guestOne: 'Masz już {{count}} {{resource}} — tryb Guest pozwala tylko na jeden.',
        guestMany: 'Dodano {{count}} {{resource}} — to limit trybu Guest.',
        freeOne: 'Masz już {{count}} {{resource}} — plan Free pozwala na {{max}}.',
        freeMany: 'Utworzono {{count}} {{resource}} — to limit planu Free.',
        guestDescription: 'Używasz TMC Studio bez konta. Utwórz darmowe konto, aby dalej budować i zapisać pracę.',
        freeDescription: 'Osiągnięto limit planu Free. Przejdź na Pro, aby pracować bez ograniczeń.',
        guestBenefits: 'Po 3 grafiki, ćwiczenia i konspekty|10 kroków na projekt|Synchronizacja i backup w chmurze|Eksport PNG',
        proBenefits: 'Nielimitowane projekty|Nielimitowane kroki|Eksport GIF i PDF|Priorytetowe wsparcie',
        continueFree: 'Kontynuuj za darmo',
        upgradePro: 'Przejdź na Pro',
        guestUsage: 'Użycie Guest',
        freePlan: 'Plan Free',
        whatYouGet: 'Co otrzymujesz:',
        comparePlans: 'Porównaj plany',
        reassurance: 'Free zostaje darmowy na zawsze. Bez karty.',
        steps: 'kroki',
        step: 'krok',
        projects: 'projekty',
        project: 'projekt',
    },
    folders: {
        createTitle: 'Utwórz folder',
        optionsTitle: 'Opcje folderu',
        name: 'Nazwa folderu',
        placeholder: 'np. Taktyka, Treningi…',
        color: 'Kolor folderu',
        cancel: 'Anuluj',
        create: 'Utwórz folder',
        save: 'Zapisz',
    },
    coaching: {
        library: 'Biblioteka', projectName: 'Nazwa projektu', saving: 'Zapisywanie…', saved: 'Zapisano', saveError: 'Błąd zapisu', help: 'Szybki przewodnik', quickStart: 'Szybki start', start: 'Zaczynamy', backToBoard: 'Wróć do tablicy',
        exercise: {
            workspaceTitle: 'Edytor ćwiczenia', nameLabel: 'Nazwa ćwiczenia', graphic: 'Grafika taktyczna', editGraphic: 'Edytuj grafikę na tablicy', editGraphicShort: 'Edytuj', drawOnBoard: 'Wróć do tablicy i rysuj', openBoard: 'Wróć do tablicy i rysuj', backToExercise: 'Zakończ edycję grafiki', noGraphic: 'Wybierz zapisaną grafikę albo otwórz tablicę i narysuj nową.', chooseGraphic: 'Wybierz grafikę z biblioteki', downloadPdf: 'Pobierz PDF', print: 'Drukuj', pdfError: 'Nie udało się utworzyć PDF. Spróbuj ponownie.', duration: 'Czas łącznie (min)', players: 'Liczba zawodników', intervals: 'Serie i przerwy', intervalsHint: 'Opcjonalnie zaplanuj np. 2 × 7 min z minutą przerwy.', clearIntervals: 'Wyczyść', sets: 'Serie', workMinutes: 'Praca (min)', restMinutes: 'Przerwa (min)', category: 'Kategoria / faza', categoryPlaceholder: 'np. rozgrzewka, pressing, budowanie', objective: 'Cel treningowy', objectivePlaceholder: 'Czego mają nauczyć się zawodnicy?', description: 'Treść ćwiczenia', descriptionPlaceholder: 'Opisz zasady i przebieg ćwiczenia.', organization: 'Organizacja', coachingPoints: 'Kluczowe wskazówki', progression: 'Progresja / regresja', equipment: 'Sprzęt',
            guide: { title: 'Stwórz kompletne ćwiczenie', 1: { title: 'Dodaj grafikę', body: 'Wybierz istniejący rysunek albo wejdź do edytora tablicy i przygotuj nowe ustawienie.' }, 2: { title: 'Opisz pracę', body: 'Ustal cel, organizację, czas, liczbę zawodników i potrzebny sprzęt.' }, 3: { title: 'Zapisz i wykorzystaj', body: 'Ćwiczenie zapisuje się automatycznie i jest dostępne w każdym konspekcie.' } },
        },
        session: {
            loadPresetGroups: 'Wczytaj grupy',
            exportPdf: 'Pobierz PDF', nameLabel: 'Nazwa konspektu', downloadPdf: 'Pobierz PDF', downloadingPdf: 'Tworzenie PDF…', print: 'Drukuj', pdfError: 'Nie udało się utworzyć PDF. Spróbuj ponownie.', eyebrow: 'Konspekt jednostki treningowej', totalTime: 'Łączny czas', date: 'Data', microcycleDay: 'Dzień mikrocyklu', venue: 'Miejsce', startTime: 'Godzina', staff: 'Sztab', objectives: 'Cele jednostki', microcycle: 'Mikrocykl', mesocycle: 'Mezocykl', playerCount: 'Liczba', exerciseLibrary: 'Biblioteka ćwiczeń', exerciseLibraryHint: 'Dodawaj zapisane ćwiczenia bezpośrednio do jednostki.', searchExercises: 'Szukaj ćwiczeń…', noExercises: 'Brak pasujących ćwiczeń.', trainingContent: 'Środki i treści treningowe', emptyPlan: 'Dodaj pierwsze ćwiczenie z biblioteki po lewej.', exerciseNotes: 'Treść, zasady, warianty i wskazówki…', squad: 'Kadra', newGroup: 'Nowa grupa', addGroup: 'Dodaj grupę pozycyjną', playersPlaceholder: 'Jeden zawodnik w wierszu', workOrganization: 'Organizacja pracy sztabu', addStaff: 'Dodaj członka sztabu', coach: 'Trener', beforeTraining: 'Przed treningiem', exerciseShort: 'Śr.', organizationNotes: 'Organizacja środków / przestrzeni', equipmentNotes: 'Sprzęt i przygotowanie', lineupNotes: 'Składy i dodatkowe notatki',
            guide: { title: 'Zbuduj konspekt treningowy', 1: { title: 'Uzupełnij dane jednostki', body: 'Wpisz datę, MD, miejsce, sztab, cele, obciążenia oraz kadrę.' }, 2: { title: 'Dodaj ćwiczenia', body: 'Korzystaj z biblioteki ćwiczeń, ustaw kolejność, czas i instrukcje dla każdego środka.' }, 3: { title: 'Zorganizuj i eksportuj', body: 'Przypisz zadania sztabowi, dodaj sprzęt i składy, a następnie wydrukuj lub zapisz PDF.' } },
        },
    },
    pricing: {
        title: 'Wybierz, jak chcesz używać TMC Studio',
        subtitle: 'Zacznij za darmo. Przejdź wyżej tylko wtedy, gdy potrzebujesz więcej.',
        mostPopular: 'Najpopularniejszy',
        currentPlan: 'Aktualny plan',
        billing: {
            monthly: 'Miesięcznie',
            yearly: 'Rocznie',
            perMonth: '/mies.',
            perYear: '/rok',
            yearlyHint: '2 miesiące gratis',
        },
        processing: 'Przetwarzanie…',
        signInHint: 'Zaloguj się przez Google albo email',
        footer: 'Możesz używać TMC Studio za darmo na zawsze.',
        footerSecond: 'Przejdź wyżej dopiero, gdy trafisz na realny limit.',
        checkoutFailed: 'Checkout nieudany. Spróbuj ponownie.',
        checkoutSessionFailed: 'Nie udało się utworzyć sesji checkout',
        genericError: 'Coś poszło nie tak',
        plans: {
            free: {
                name: 'Free',
                price: 'W cenie',
                period: ' po zalogowaniu',
                microcopy: 'To domyślny plan po logowaniu',
                features: 'Po 3 grafiki, ćwiczenia i konspekty|Synchronizacja i backup w chmurze|Eksport PNG|Organizacja folderami',
                cta: 'Kontynuuj za darmo',
            },
            pro: {
                name: 'Pro',
                price: '$9',
                period: '/miesiąc',
                microcopy: 'Dla trenerów, którzy tworzą dużo ćwiczeń i eksportów',
                features: 'Nielimitowane projekty|Eksport GIF i PDF|Nielimitowane kroki|Priorytetowe wsparcie',
                cta: 'Przejdź na Pro',
            },
            team: {
                name: 'Team',
                price: '$29',
                period: '/miesiąc',
                microcopy: 'Pro + zaproś sztab bezpiecznym linkiem',
                features: '5 członków zespołu|Wspólne rozliczenie|Indywidualne przestrzenie pracy|Wszystko z Pro',
                cta: 'Przejdź na Team',
            },
        },
    },
    projects: {
        title: 'Projekty',
        back: 'Wróć',
        recentProjects: 'Ostatnie projekty',
        recentHint: 'Kontynuuj od miejsca, w którym skończyłeś',
        refresh: 'Odśwież projekty',
        close: 'Zamknij panel',
        newProject: 'Nowy projekt',
        defaultExerciseName: 'Nowe ćwiczenie',
        defaultSessionName: 'Nowy konspekt',
        defaultSessionNameWithDate: 'Trening - {date}',
        exerciseFromGraphicName: 'Ćwiczenie — {{name}}',
        kind: 'Rodzaj',
        folder: 'Folder',
        noFolder: 'Bez folderu',
        tags: 'Tagi',
        addTag: 'Dodaj tag i naciśnij Enter',
        removeTag: 'Usuń tag {{tag}}',
        organize: 'Folder i tagi',
        organizeTitle: 'Folder i tagi: {{name}}',
        done: 'Gotowe',
        filterByType: 'Filtruj według rodzaju',
        descriptionPlaceholder: 'Cel, organizacja, przebieg i najważniejsze wskazówki…',
        tutorial: {
            help: 'Jak to działa?', open: 'Tutorial biblioteki', close: 'Zamknij tutorial', step: 'Krok {{current}} z 3', back: 'Wstecz', next: 'Dalej', done: 'Gotowe',
            items: {
                0: { title: '1. Narysuj grafikę', body: 'Zapisz ustawienie na tablicy jako Grafikę. To będzie wizualna baza ćwiczenia.' },
                1: { title: '2. Zbuduj ćwiczenie', body: 'Utwórz ćwiczenie z aktualnej grafiki albo wybierz inną z biblioteki. Dodaj czas, liczbę zawodników, organizację i coaching points.' },
                2: { title: '3. Ułóż konspekt', body: 'Dodaj gotowe ćwiczenia do konspektu, ustaw kolejność, czas i notatki. Łączny czas liczy się automatycznie.' },
            },
        },
        exercise: {
            createFromThisGraphic: 'Utwórz ćwiczenie z tej grafiki', graphic: 'Grafika ćwiczenia', noGraphics: 'Najpierw utwórz grafikę', useGraphic: 'Użyj grafiki', refreshGraphic: 'Odśwież z grafiki', usingGraphic: 'Używana grafika: {{name}}', duration: 'Czas (min)', players: 'Zawodnicy', playersPlaceholder: 'np. 8 + 2 bramkarzy', organization: 'Organizacja i przebieg', coachingPoints: 'Najważniejsze wskazówki',
        },
        session: {
            agenda: 'Plan ćwiczeń', total: 'Łącznie: {{minutes}} min', noExercises: 'Najpierw utwórz ćwiczenie', add: 'Dodaj', empty: 'Dodaj pierwsze ćwiczenie do konspektu.', moveUp: 'Przenieś wyżej', moveDown: 'Przenieś niżej', remove: 'Usuń z konspektu', itemDuration: 'Czas ćwiczenia w minutach', notes: 'Notatka do tego ćwiczenia',
        },
        type: { all: 'Wszystkie', graphic: 'Grafika', exercise: 'Ćwiczenie', session: 'Konspekt' },
        search: 'Szukaj projektów…',
        clearSearch: 'Wyczyść wyszukiwanie',
        sortBy: 'Sortuj:',
        results: 'Wyniki: {{count}}',
        pinned: 'Przypięte',
        folders: 'Foldery',
        newFolder: 'Nowy folder',
        newSubfolder: 'Nowy podfolder',
        allProjects: 'Wszystkie projekty',
        unsorted: 'Nieposegregowane', selectProject: 'Zaznacz {{name}}', unselectProject: 'Odznacz {{name}}', selectedCount: 'Zaznaczono: {{count}}', selectAll: 'Zaznacz widoczne', clearSelection: 'Wyczyść', deleteSelected: 'Usuń zaznaczone', deleteSelectedTitle: 'Usunąć {{count}} projektów?', deleteSelectedDescription: 'Wybrane projekty zostaną trwale usunięte. Konspekty zachowają zapisane migawki ćwiczeń.',
        moveToRoot: 'Przenieś do głównego',
        noProjectsYet: 'Brak projektów',
        createProject: 'Utwórz projekt',
        signInSync: 'Zaloguj się, aby synchronizować projekty',
        authRequired: 'Projekty w chmurze wymagają logowania',
        signIn: 'Zaloguj',
        createFirst: 'Utwórz pierwszy projekt, aby zacząć',
        cloudSync: 'Synchronizacja z chmurą włączona',
        signInCloud: 'Zaloguj się, aby synchronizować z chmurą',
        current: 'Aktualny',
        projectName: 'Nazwa projektu',
        saving: 'Zapisywanie…',
        unsaved: 'Niezapisane zmiany',
        saveError: 'Błąd zapisu',
        saved: 'Zapisano',
        duplicate: 'Powiel',
        projectActions: 'Akcje projektu {{name}}',
        delete: 'Usuń',
        unpin: 'Odepnij',
        pinTop: 'Przypnij na górze',
        removeFavorite: 'Usuń z ulubionych',
        addFavorite: 'Dodaj do ulubionych',
        editFolder: 'Edytuj folder',
        moveRoot: 'Przenieś do głównego',
        deleteFolder: 'Usuń folder',
        dropInside: 'Upuść wewnątrz',
        dropAbove: 'Upuść powyżej',
        dropBelow: 'Upuść poniżej',
        dragReorder: 'Przeciągnij, aby zmienić kolejność',
        expand: 'Rozwiń',
        collapse: 'Zwiń',
        deleteTitle: 'Usuń projekt',
        deleteDescription: 'Czy na pewno usunąć „{{name}}”? Tej akcji nie można cofnąć.',
        deleteFallback: 'Czy na pewno usunąć ten projekt?',
        sort: {
            recent: 'Ostatnie',
            nameAsc: 'Nazwa (A-Z)',
            nameDesc: 'Nazwa (Z-A)',
            favorites: 'Ulubione najpierw',
            lastOpened: 'Ostatnio otwarte',
        },
        time: {
            justNow: 'Przed chwilą',
            minutesAgo: '{{count}} min temu',
            hoursAgo: '{{count}} godz. temu',
            daysAgo: '{{count}} dni temu',
        },
    },
    help: {
        panelLabel: 'Panel pomocy',
        title: 'Pomoc i skróty',
        close: 'Zamknij panel pomocy',
        shortcuts: 'Skróty klawiszowe',
        quickTools: 'Szybkie narzędzia',
        tips: 'Wskazówki',
        tutorial: 'Tutorial',
        restartTutorial: 'Uruchom ponownie przewodnik',
        saveStatus: 'Status zapisu',
        save: 'Zapisz',
        allSaved: 'Wszystkie zmiany zapisane',
        saving: 'Zapisywanie…',
        unsaved: 'Niezapisane zmiany',
        error: 'Błąd zapisu',
        tools: {
            'zoom-fit': { label: 'Dopasuj zoom', description: 'Dopasuj widok do boiska' },
            'focus-mode': { label: 'Tryb skupienia', description: 'Minimalny UI do pracy bez rozpraszania' },
            'print-mode': { label: 'Tryb druku', description: 'Czysty układ do eksportu' },
            export: { label: 'Eksport', description: 'Eksportuj jako PNG/PDF/GIF' },
        },
        tipsList: {
            'tip-1': 'Zaznacz zawodnika i naciśnij →, aby dodać strzałkę z numerem',
            'tip-2': 'Kliknij zawodnika dwa razy, aby szybko edytować jego numer',
            'tip-3': 'Przytrzymaj Shift podczas klikania, aby zaznaczać wiele elementów',
            'tip-4': 'Naciśnij ?, aby zobaczyć pełną ściągawkę skrótów',
            'tip-5': 'Użyj Ctrl+Scroll, aby przybliżać i oddalać',
            'tip-6': 'Space + przeciągnięcie przesuwa płótno',
        },
    },
    faq: {
        title: 'Pomoc',
        subtitle: 'Znajdź odpowiedzi na najczęstsze pytania',
        search: 'Szukaj w pomocy…',
        noResults: 'Nie znaleziono pasujących pytań. Spróbuj innego wyszukiwania.',
        categories: {
            gettingStarted: 'Pierwsze kroki',
            proFeatures: 'Funkcje Pro',
            clubPremium: 'Club Premium',
            troubleshooting: 'Rozwiązywanie problemów',
            accountBilling: 'Konto i płatności',
            coachingWorkflow: 'Biblioteka i workflow trenera',
        },
        items: {
            addPlayer: { question: 'Jak dodać zawodnika?', answer: 'Naciśnij P, aby dodać zawodnika gospodarzy, lub Shift+P dla gości. Możesz też kliknąć prawym przyciskiem na boisku i wybrać "Dodaj zawodnika". Użyj klawiszy 1-6 dla błyskawicznych formacji.' },
            addArrow: { question: 'Jak rysować strzałki?', answer: 'Naciśnij A dla strzałek podania (ciągła linia), R dla biegów (przerywana) lub S dla strzałów (podwójna linia). Kliknij na boisku, przeciągnij do punktu końcowego i puść. Shift+N włącza auto-numerację.' },
            saveProject: { question: 'Jak zapisać projekt?', answer: 'Naciśnij ⌘S (Ctrl+S w Windows), aby zapisać. Projekty automatycznie zapisują się w chmurze co 30 sekund. Otwórz panel Projektów (ikona folderu w TopBar), aby wyświetlić, zmienić nazwę lub organizować projekty.', cta: 'Zapisz teraz' },
            freePlan: { question: 'Co mogę robić za darmo?', answer: 'Darmowy plan obejmuje po 3 grafiki, ćwiczenia i konspekty, 10 kroków na projekt, eksport PNG i JPG oraz synchronizację w chmurze. Przejdź na Pro, aby mieć nielimitowaną bibliotekę.', cta: 'Porównaj plany' },
            exportGifPdf: { question: 'Jak eksportować GIF lub PDF?', answer: 'Eksport GIF i PDF to funkcje Pro. Kliknij przycisk Eksport w TopBar i wybierz "Animacja GIF" lub "PDF". Jeśli nie widzisz tych opcji, jesteś na darmowym planie.', cta: 'Przejdź na Pro' },
            unlimitedProjects: { question: 'Czy mogę tworzyć nielimitowane projekty?', answer: 'Nielimitowane projekty i kroki są dostępne w planie Pro. Darmowy plan pozwala na trzy elementy każdego rodzaju po 10 kroków.', cta: 'Zobacz plany Pro' },
            manageSubscription: { question: 'Jak zarządzać subskrypcją?', answer: 'Kliknij swój awatar w TopBar i wybierz "Konto i płatności". Otworzy się Stripe Customer Portal, gdzie możesz zaktualizować metodę płatności, zobaczyć faktury lub zmienić plan.', cta: 'Otwórz płatności' },
            squadSlots: { question: 'Ilu zawodników mogę mieć w kadrze?', answer: 'Darmowy plan pozwala na 5 zawodników w kadrze. Pro i Club Premium odblokowują do 35 zawodników na drużynę (140 łącznie w 4 drużynach). Zablokowane sloty mają ikonę kłódki.', cta: 'Przejdź na wyższy plan' },
            addMembers: { question: 'Jak dodać członków drużyny?', answer: 'Otwórz ustawienia Team, wpisz email członka i utwórz link zaproszenia. Udostępnij mu link; dostęp otrzyma po zaakceptowaniu zaproszenia na wskazanym koncie.', cta: 'Otwórz panel drużyny' },
            manageBilling: { question: 'Jak zarządzać płatnościami Club Premium?', answer: 'Kliknij awatar → "Konto i płatności", aby otworzyć Stripe Customer Portal. Możesz tam zaktualizować metodę płatności, zobaczyć faktury i zarządzać subskrypcją Club Premium.', cta: 'Otwórz płatności' },
            removeMember: { question: 'Jak usunąć członka drużyny?', answer: 'Otwórz panel Drużyny w Inspektorze. Znajdź członka, którego chcesz usunąć, i kliknij ikonę kosza obok jego nazwy. Potwierdź, aby natychmiast cofnąć jego dostęp do Club Premium.' },
            saveFailed: { question: 'Projekt się nie zapisał. Co robić?', answer: 'Najpierw sprawdź połączenie z internetem. Jeśli jesteś online, spróbuj ręcznie zapisać ⌘S (Ctrl+S w Windows). Ikona błędu w pasku statusu jest klikalna — ponawia próbę zapisu automatycznie.', cta: 'Zapisz ręcznie' },
            changesNotVisible: { question: 'Nie widzę zmian na planszy', answer: 'Upewnij się, że odpowiednia warstwa jest widoczna (Inspektor → zakładka Warstwy). Sprawdź, czy jesteś na właściwym kroku (dolna oś czasu). Naciśnij 0, aby zresetować widok, lub sprawdź, czy nie jesteś w trybie druku (W).' },
            exportNotWorking: { question: 'Eksport nie działa', answer: 'Dla eksportu PNG sprawdź uprawnienia przeglądarki (niektóre blokują pobieranie). Dla GIF upewnij się, że masz co najmniej 2 kroki z różną zawartością. Dla PDF sprawdź, czy masz plan Pro.' },
            changePlan: { question: 'Jak zmienić plan?', answer: 'Kliknij swój awatar w TopBar i wybierz "Konto i płatności", aby zarządzać subskrypcją, lub otwórz modal Pricing, aby porównać plany i dokonać upgrade\'u.', cta: 'Zobacz plany' },
            cancelSubscription: { question: 'Jak anulować subskrypcję?', answer: 'Kliknij awatar → "Konto i płatności", aby otworzyć Stripe Customer Portal. Wybierz "Anuluj plan" — dostęp pozostanie aktywny do końca okresu rozliczeniowego.', cta: 'Przejdź do płatności' },
            guestRegister: { question: 'Jak utworzyć darmowe konto?', answer: 'Kliknij "Zaloguj się" w menu TopBar i wybierz "Rejestracja". Użyj Google do rejestracji jednym kliknięciem lub wpisz email i hasło. Darmowe pozostaje darmowe — bez karty kredytowej.', cta: 'Zarejestruj się' },
            lineupPresets: { question: 'Jak zapisać i szybko wczytać ustawienie drużyny?', answer: 'Ustaw zawodników na boisku, otwórz Ustawienia → Skład i zapisz nazwany wariant, np. Low block. Potem wybierzesz go pod nazwą drużyny na ławce albo skrótem Option+1–9 na macOS i Alt+1–9 na Windows/Linux. Ołówek obok wyboru otwiera szybką edycję.' },
            exercisesSessions: { question: 'Jak utworzyć ćwiczenie i konspekt?', answer: 'W Projektach utwórz Grafikę, następnie Ćwiczenie i dołącz do niego grafikę. Uzupełnij organizację, coaching points i interwały. W Konspekcie dodaj ćwiczenia w kolejności, wybierz kadrę i sztab, a następnie wydrukuj lub pobierz PDF.' },
            returnFromLineupEdit: { question: 'Dokąd wracam po edycji presetu?', answer: 'TMC Studio wraca tam, skąd rozpocząłeś. Edycja uruchomiona w Ustawieniach wraca do Składu. Edycja uruchomiona z ławki zapisuje preset i pozostawia Cię na tablicy.' },
        },
    },
    bottomSteps: {
        previous: 'Poprzedni krok (←)',
        play: 'Odtwórz (Space)',
        pause: 'Pauza (Space)',
        next: 'Następny krok (→)',
        loop: 'Pętla (L)',
        duration: 'Czas kroku (tempo odtwarzania)',
        rename: 'Kliknij dwa razy, aby zmienić nazwę',
        delete: 'Usuń krok (X)',
        duplicate: 'Powiel krok',
        moveHint: 'Przeciągnij, aby zmienić kolejność (Alt+←/→) · dwuklik: zmiana nazwy',
        add: 'Dodaj krok (N)',
        counter: 'Krok {{current}} / {{total}}',
        defaultName: 'Krok {{number}}',
    },
    selection: {
        duplicate: 'Powiel (⌘D)',
        bringFront: 'Przenieś na wierzch',
        sendBack: 'Przenieś na spód',
        delete: 'Usuń (Del)',
    },
    teamsPanel: {
        title: 'Kolory drużyn',
        teamSuffix: '{{team}}',
        name: 'Nazwa',
        primaryColor: 'Kolor podstawowy',
        secondaryColor: 'Kolor dodatkowy',
        goalkeeperColor: 'Kolor bramkarza',
        kitPresets: 'Gotowe zestawy',
        kits: {
            redWhite: 'Czerwono-biały',
            blueWhite: 'Niebiesko-biały',
            greenWhite: 'Zielono-biały',
            blackWhite: 'Czarno-biały',
            whiteBlack: 'Biało-czarny',
            yellowBlue: 'Żółto-niebieski',
            orangeBlack: 'Pomarańczowo-czarny',
            navySkyblue: 'Granatowo-błękitny',
        },
        help: 'Nazwy i kolory zapisują się automatycznie i od razu obejmują wszystkich zawodników.',
        team1: 'Drużyna 1',
        team2: 'Drużyna 2',
        team3: 'Drużyna 3',
        team4: 'Drużyna 4',
    },
    squadBench: {
        title: 'Ławka składu',
        home: 'Gospodarze',
        away: 'Goście',
        team3: 'Drużyna 3',
        team4: 'Drużyna 4',
        empty: 'puste',
        add: 'dodaj',
        addPlayer: 'Dodaj zawodnika',
        addSquadPlayer: 'Dodaj zawodnika do składu',
        addFirstPlayer: 'Dodaj pierwszego zawodnika',
        upgradeSlots: 'Przejdź na Pro, aby mieć więcej miejsc w składzie',
        unlockSlots: 'Przejdź na Pro, aby odblokować więcej miejsc w składzie',
        freeLimitNotice: 'W darmowej wersji masz {{freeLimit}} zawodników w składzie. Zaloguj się, żeby zapisywać skład, a Pro odblokuje do {{premiumLimit}} zawodników na drużynę.',
        dragToPitch: '{{name}} (#{{number}}) — przeciągnij na boisko',
        playerAria: '{{name}}, numer {{number}}, {{team}}{{locked}}',
        locked: ' — zablokowany',
        remove: 'Usuń {{name}}',
        removeAria: 'Usuń {{name}} ze składu',
        editor: 'Pełny edytor składu w Ustawieniach',
        editRoster: 'Edytuj skład',
        hide: 'Ukryj ławkę składu',
        show: 'Pokaż ławkę składu',
        switchCurrent: 'Zmień drużynę — teraz: {{team}}',
        currentTeam: 'Aktualna drużyna: {{team}}. Kliknij, aby zmienić.',
        teamCount: '{{team}} ({{count}})',
        switchToTeam: 'Przełącz na {{team}} (zawodnicy: {{count}})',
        namePlaceholder: 'Zawodnik',
        numberPlaceholder: '#',
        cancel: 'Anuluj',
        dragHint: 'Przeciągnij zawodnika na boisko, aby go ustawić',
        collapsedSetup: 'Skonfiguruj kadrę w Ustawieniach albo',
        collapsedCount: '{{count}} w kadrze — kliknij oko, aby pokazać',
        teams: 'Drużyny', tacticalLineups: 'Ustawienia taktyczne', chooseTacticalLineup: 'Wybierz ustawienie', editSelectedLineup: 'Opcje wybranego ustawienia', applySelectedLineup: 'Wczytaj', editOnPitch: 'Edytuj na boisku', noTacticalLineups: 'Brak zapisanych ustawień dla tej drużyny.', closeTeamMenu: 'Zamknij menu drużyny',
    },
    pitchPanel: {
        boardView: 'Widok boiska',
        boardFull: 'Pełne boisko',
        boardHalf2d: 'Połowa boiska',
        boardPenalty2d: 'Pole karne',
        boardResetTitle: 'Zresetować planszę?',
        boardResetDesc: 'To usunie wszystkie elementy i przywróci domyślny układ. Tej operacji nie można cofnąć.',
        boardResetConfirm: 'Zresetuj planszę',
        title: 'Wygląd boiska',
        theme: 'Motyw',
        grass: 'Trawa',
        indoor: 'Hala',
        chalk: 'Kreda',
        futsal: 'Futsal',
        showStripes: 'Pokaż pasy',
        withoutLines: 'Bez linii',
        printFriendly: 'Tryb do druku',
        customColors: 'Kolory niestandardowe',
        fieldColor: 'Kolor pola',
        lineColor: 'Kolor linii',
        orientation: 'Orientacja',
        landscape: 'Poziomo',
        portrait: 'Pionowo',
        help: 'Wybierz gotowy motyw albo dostosuj kolory ręcznie.',
    },
    tutorial: {
        finish: 'Zakończ',
        step: 'Krok {{current}} z {{total}}',
        skip: 'Pomiń',
        back: 'Wstecz',
        next: 'Dalej',
        startBuilding: 'Zacznij trenować',
        ariaStep: 'Krok tutoriala {{id}}: {{title}}',
        demos: {
            fastInput: 'Szybkie dodawanie',
            homePlayer: 'Zawodnik gospodarzy',
            awayPlayer: 'Zawodnik gości',
            formation: 'Formacja',
            arrows: 'Rodzaje strzałek',
            passArrow: 'Podanie',
            runArrow: 'Bieg',
            shootArrow: 'Strzał',
            autoNumber: 'Auto-numeracja',
            inspector: 'Inspektor',
            output: 'Formaty eksportu',
            share: 'Udostępnij',
            projects: 'Projekty',
            threePerType: '3 / rodzaj',
            cloud: 'Chmura',
            pro: 'Pro',
            squad: 'Kadra',
            steps: 'Oś czasu',
            play: 'Odtwórz',
            newStep: 'Nowy krok',
            loop: 'Pętla',
            save: 'Zapis i projekty',
            saveShortcut: 'Zapisz',
            myProject: 'Mój trening',
            justNow: 'Przed chwilą',
            saved: 'Zapisano',
            shortcutSheet: 'Ściągawka skrótów',
            team: 'Zarządzanie drużyną',
            admin: 'Admin',
            member: 'Członek',
            active: 'Aktywny',
            inviteMember: 'Zaproś członka',
        },
        steps: {
            1: { eyebrow: '🏋️ Rozgrzewka', title: 'Ustaw zawodników', description: 'Naciśnij P, aby dodać gospodarzy, Shift+P dla gości. Użyj klawiszy 1-6, by błyskawicznie ustawić formację. Twoja tablica taktyczna startuje tutaj.', target: 'Dodawanie graczy', cta: 'Rysuj taktykę' },
            2: { eyebrow: '🏃 Ruch', title: 'Narysuj swoją taktykę', description: 'Naciśnij A dla strzałek podania, R dla biegów, S dla strzałów. Kliknij i przeciągnij na boisku, by dokładnie pokazać, jak ma grać twoja drużyna.', target: 'Strzałki taktyczne', cta: 'Ustaw kierunek' },
            3: { eyebrow: '🧭 Kierunek', title: 'Pokaż, gdzie patrzą zawodnicy', description: 'Zaznacz zawodnika i naciśnij [ lub ], by go obrócić. Naciśnij V, by pokazać stożek widzenia — idealne do ćwiczeń pressingu i ustawienia defensywy.', target: 'Orientacja', cta: 'Dodaj sprzęt' },
            4: { eyebrow: '🏋️ Sprzęt', title: 'Zbuduj swoje ćwiczenie', description: 'Dodaj bramki (J), pachołki (K), drabinki (Y) i płotki (U). Użyj Z dla stref, T dla tekstu. Wszystko, czego trener potrzebuje na sesję.', target: 'Sprzęt treningowy', cta: 'Zarządzaj kadrą' },
            5: { eyebrow: '📋 Kadra', title: 'Pełna kadra pod ręką', description: 'Squad Bench przechowuje twoich zawodników. Przeciągnij ich na boisko, by dokonać zmiany lub dodać nową rolę. Kliknij ikonę oka, by ukryć/pokazać.', target: 'Ławka rezerwowych', cta: 'Animuj taktykę' },
            6: { eyebrow: '▶️ Animacja', title: 'Ożyw swoją taktykę', description: 'Naciśnij N, by dodać nowy krok, a następnie dostosuj pozycje. Naciśnij Space, by odtworzyć — obserwuj, jak ćwiczenie animuje się krok po kroku. Pętla pod L.', target: 'Oś czasu', cta: 'Zapisz projekt' },
            7: { eyebrow: '📚 Biblioteka', title: 'Zamień grafiki w gotowy trening', description: 'Otwórz Projekty: zapisz tablicę jako Grafikę, zbuduj z niej Ćwiczenie z opisem trenerskim, a następnie dodaj ćwiczenia do uporządkowanego Konspektu.', target: 'Biblioteka trenerska', cta: 'Udostępnij i eksportuj' },
            8: { eyebrow: '📤 Udostępnij', title: 'Eksportuj i podziel się z drużyną', description: 'Eksportuj ćwiczenie jako PNG, animację GIF lub PDF. Naciśnij ?, by zobaczyć pełną ściągawkę skrótów. Twoja biblioteka trenerska gotowa na mecz.', target: 'Eksport', cta: 'Zacznij trenować' },
        },
    },
    cheatsheet: {
        title: 'Skróty klawiszowe',
        close: 'Zamknij (albo naciśnij ?)',
        closeShortcuts: 'Zamknij skróty (?)',
        keyboardShortcuts: 'Skróty klawiszowe (?)',
        closeAria: 'Zamknij skróty klawiszowe',
        showAria: 'Pokaż skróty klawiszowe',
        categories: 'Kategorie skrótów',
        press: 'Naciśnij',
        toToggle: 'aby przełączyć',
        tabs: { Elements: 'Elementy', Edit: 'Edycja', View: 'Widok', More: 'Więcej' },
        sections: {
            'Elements': 'Elementy', 'Edit': 'Edycja', 'View & Pitch': 'Widok i boisko',
            'Steps & Playback': 'Kroki i odtwarzanie', 'Export': 'Eksport',
            'Formations': 'Formacje', 'Arrow Numbering': 'Numeracja strzałek',
        },
    },
    palette: {
        placeholder: 'Wpisz polecenie lub szukaj…',
        noResults: 'Nie znaleziono poleceń',
        pro: 'Pro',
        navigate: 'nawiguj',
        select: 'wybierz',
        close: 'zamknij',
        categories: { elements: 'Elementy', edit: 'Edycja', view: 'Widok', steps: 'Kroki', export: 'Eksport', presets: 'Szablony' },
    },
    commands: {
        'add-home-player': 'Dodaj zawodnika gospodarzy',
        'add-away-player': 'Dodaj zawodnika gości',
        'add-ball': 'Dodaj piłkę',
        'add-pass-arrow': 'Dodaj strzałkę podania',
        'add-run-arrow': 'Dodaj strzałkę biegu',
        'add-shoot-arrow': 'Dodaj strzałkę strzału',
        'add-dribble-arrow': 'Dodaj strzałkę dryblingu',
        'add-zone': 'Dodaj strefę',
        'add-ellipse-zone': 'Dodaj strefę elipsy',
        'add-freehand-draw': 'Dodaj rysunek odręczny',
        'add-text': 'Dodaj tekst',
        'duplicate': 'Powiel zaznaczenie',
        'delete': 'Usuń zaznaczenie',
        'undo': 'Cofnij',
        'redo': 'Ponów',
        'select-all': 'Zaznacz wszystko',
        'clear-selection': 'Wyczyść zaznaczenie',
        'toggle-inspector': 'Przełącz inspektor',
        'toggle-cheatsheet': 'Przełącz skróty',
        'toggle-grid': 'Przełącz siatkę',
        'toggle-snap': 'Przełącz przyciąganie',
        'focus-mode': 'Tryb skupienia',
        'add-step': 'Dodaj krok',
        'prev-step': 'Poprzedni krok',
        'next-step': 'Następny krok',
        'play': 'Odtwórz',
        'pause': 'Pauza',
        'toggle-loop': 'Przełącz pętlę',
        'export-png': 'Eksportuj PNG',
        'export-steps': 'Eksportuj wszystkie kroki PNG',
        'export-gif': 'Eksportuj animowany GIF',
        'export-pdf': 'Eksportuj PDF (wszystkie kroki)',
        'export-svg': 'Eksportuj SVG',
        confirm: {
            clearAllTitle: 'Wyczyścić wszystkie elementy?',
            clearAllDescription: 'To usunie wszystkie elementy z bieżącego kroku. Możesz cofnąć tę akcję przez Cmd+Z.',
            clearAllConfirm: 'Wyczyść wszystko',
        },
        toast: {
            groupUngrouped: 'Rozgrupowano',
            selectionLockToggled: 'Przełączono blokadę',
            selectionLocked: 'Zablokowano zaznaczenie',
            selectionUnlocked: 'Odblokowano zaznaczenie',
            team1Player: 'Zawodnik drużyny 1',
            team2Player: 'Zawodnik drużyny 2',
            team3Player: 'Zawodnik drużyny 3',
            team4Player: 'Zawodnik drużyny 4',
            ballCluster: 'Grupa piłek',
            ball: 'Piłka',
            text: 'Tekst',
            lyingMannequin: 'Leżący manekin',
            mannequin: 'Manekin',
            discMarker: 'Znacznik płaski',
            pole: 'Tyczka',
            cone: 'Pachołek',
            hoop: 'Obręcz',
            hurdle: 'Płotek',
            ladder: 'Drabinka',
            miniGoal: 'Mini bramka',
            goal: 'Bramka',
            redo: 'Przywrócono',
            undo: 'Cofnięto',
            deleted: 'Usunięto',
            duplicated: 'Powielono',
            dribbleArrow: 'Strzałka dryblingu',
            copied: 'Skopiowano',
            allElementsCleared: 'Wyczyszczono wszystkie elementy',
            noDrawingsToClear: 'Brak rysunków do usunięcia',
            drawingsCleared: 'Wyczyszczono rysunki: {{count}} · Cofnij: Cmd+Z',
            pasted: 'Wklejono',
            enableOrientation: 'Najpierw włącz orientację zawodników (Inspektor → Orientacja)',
            orientationModeOn: 'Tryb orientacji zawodników: WŁ',
            orientationModeOff: 'Tryb orientacji zawodników: WYŁ',
            visionAllOn: 'Widzenie: WŁ. — {{count}} zawodników',
            visionAllOff: 'Widzenie: WYŁ. — {{count}} zawodników',
            noPlayersOnBoard: 'Brak zawodników na planszy',
            visionSelected: 'Przełączono widzenie dla zawodników: {{count}}',
            visionSelectedOn: 'Widzenie włączone dla zawodników: {{count}}',
            selectPlayersForVision: 'Zaznacz zawodników, aby przełączyć widzenie',
            groupCreated: 'Utworzono grupę',
            goalkeeperSet: 'Ustawiono bramkarza: {{team}}',
            goalkeeperColor: 'Kolor GK {{team}}: {{color}}',
            gridHidden: 'Siatka ukryta',
            gridVisible: 'Siatka widoczna',
            snapEnabled: 'Przyciąganie włączone',
            snapDisabled: 'Przyciąganie wyłączone',
            passArrowAutoNumber: 'Strzałka podania (auto-numer)',
            runArrowAutoNumber: 'Strzałka biegu (auto-numer)',
            zoneShapeChanged: 'Zmieniono kształt strefy',
            savedCloud: 'Zapisano w chmurze',
            cloudSaveFailed: 'Zapis w chmurze nieudany',
            savedLocal: 'Zapisano lokalnie',
            shapeChanged: 'Zmieniono kształt',
            portraitMode: 'Tryb pionowy (75%)',
            landscapeMode: 'Tryb poziomy',
            printModeOff: 'Tryb druku WYŁ.',
            printModeOn: 'Tryb druku WŁ.',
            stepAdded: 'Dodano nowy krok',
            stepDeleted: 'Usunięto krok',
            stepLimitFree: 'Masz {{count}}/10 kroków. Przejdź na Pro, aby mieć bez limitu.',
            loopOn: 'Pętla włączona',
            loopOff: 'Pętla wyłączona',
            autoNumberingOn: 'Auto-numeracja WŁ.',
            autoNumberingOff: 'Auto-numeracja WYŁ.',
            background: 'Tło: {{color}}',
            backgroundRemoved: 'Usunięto tło',
            signInToSave: 'Zaloguj się, by zapisywać projekty — to darmowe',
            fontSize: 'Rozmiar tekstu: {{size}}px',
            previousColor: 'Poprzedni kolor',
            nextColor: 'Następny kolor',
            normal: 'Normalny',
            bold: 'Pogrubienie',
            italic: 'Kursywa',
            thinnerStroke: 'Cieńsza linia',
            thickerStroke: 'Grubsza linia',
            alignPrev: 'Poprzednie wyrównanie',
            alignNext: 'Następne wyrównanie',
            arrowNumberToggled: 'Przełączono numer strzałki',
            resizedUp: 'Powiększono +10%',
            resizedDown: 'Zmniejszono -10%',
            resizedTo: 'Zmieniono rozmiar na {{percent}}%',
            layerControlSoon: 'Kontrola warstw wkrótce',
            playerAdded: 'Dodano zawodnika',
            ballAdded: 'Dodano piłkę',
            arrowAdded: 'Dodano strzałkę',
            zoneAdded: 'Dodano strefę',
            colorChanged: 'Zmieniono kolor',
            switchedTeam: 'Zmieniono drużynę na {{team}}',
            playerColorChanged: 'Zmieniono kolor zawodnika (Alt+↓/↑ przełącza)',
            textColorChanged: 'Zmieniono kolor tekstu (Alt+↓/↑ przełącza)',
            equipmentUp: 'Sprzęt +15%',
            equipmentDown: 'Sprzęt -15%',
            orientationReset: 'Zresetowano orientację zawodnika',
            playerOrientation: 'Orientacja zawodnika {{delta}}°',
            rotatedLeft15: 'Obrócono -15°',
            rotatedRight15: 'Obrócono +15°',
            rotatedLeft90: 'Obrócono -90°',
            rotatedRight90: 'Obrócono +90°',
            formationApplied: 'Zastosowano {{formation}} ({{team}})',
            lineupApplied: 'Wczytano zapisany skład {{slot}}',
            lineupEmpty: 'Slot składu {{slot}} jest pusty',
        },
    },
    shortcuts: {
        'add-home-player': 'Dodaj zawodnika gosp.',
        'add-away-player': 'Dodaj zawodnika gości',
        'add-team3-player': 'Dodaj zawodnika drużyny 3',
        'add-team4-player': 'Dodaj zawodnika drużyny 4',
        'add-ball': 'Dodaj piłkę',
        'pass-arrow': 'Strzałka podania',
        'run-arrow': 'Strzałka biegu',
        'shot-arrow': 'Strzałka strzału',
        'dribble-arrow': 'Strzałka dryblingu',
        'rect-zone': 'Strefa prostokątna',
        'ellipse-zone': 'Strefa elipsa',
        'text-label': 'Etykieta tekstowa',
        'freehand-draw': 'Rysunek odręczny',
        'highlighter': 'Zakreślacz',
        'clear-drawings': 'Wyczyść rysunki',
        'goal': 'Bramka (Shift mini)',
        'mannequin': 'Manekin (Shift płaski)',
        'cone': 'Pachołek (Shift wysoki)',
        'ladder': 'Drabinka',
        'hoop': 'Obręcz',
        'hurdle': 'Płotek',
        'rotate-minus': 'Obróć -15°',
        'rotate-plus': 'Obróć +15°',
        'rotate-minus-90': 'Obróć -90°',
        'rotate-plus-90': 'Obróć +90°',
        'undo': 'Cofnij',
        'redo': 'Ponów',
        'copy': 'Kopiuj',
        'paste': 'Wklej',
        'duplicate': 'Powiel',
        'delete': 'Usuń',
        'deselect': 'Odznacz wszystko',
        'select-all': 'Zaznacz wszystko',
        'cycle-player-shape': 'Zmień kształt zawodnika',
        'cycle-zone-shape': 'Zmień kształt strefy',
        'group-selection': 'Grupuj zaznaczenie',
        'ungroup-selection': 'Rozgrupuj',
        'lock-unlock': 'Zablokuj / Odblokuj',
        'quick-edit-number': 'Szybka edycja numeru',
        'cycle-color': 'Zmień kolor',
        'stroke-width': 'Grubość linii',
        'focus-mode': 'Tryb skupienia',
        'toggle-inspector': 'Przełącz inspektor',
        'player-orientation': 'Orientacja zawodnika',
        'print-mode': 'Tryb wydruku',
        'cycle-pitch-view': 'Zmień widok boiska',
        'all-shortcuts': 'Wszystkie skróty',
        'command-palette': 'Paleta poleceń',
        'toggle-orientation': 'Przełącz orientację',
        'toggle-orientation-mode': 'Przełącz tryb orientacji',
        'open-projects': 'Otwórz projekty',
        'zoom-in': 'Przybliż',
        'zoom-out': 'Oddal',
        'toggle-shortcuts': 'Przełącz skróty',
        'prev-next-step': 'Poprzedni/Następny krok',
        'play-pause': 'Odtwórz/Pauza',
        'new-step': 'Nowy krok',
        'delete-step': 'Usuń krok',
        'add-step': 'Dodaj krok',
        'toggle-loop': 'Przełącz pętlę',
        'export-png': 'Eksportuj PNG',
        'export-all-png': 'Eksportuj wszystkie PNG',
        'export-gif': 'Eksportuj GIF',
        'export-pdf': 'Eksportuj PDF',
        'home-formation': 'Zastosuj formację gosp.',
        'away-formation': 'Zastosuj formację gości',
        'set-gk': 'Ustaw bramkarza / kolor GK',
        'pass-num': 'Podanie + numer',
        'run-num': 'Bieg + numer',
        'toggle-auto-num': 'Przełącz auto-numerację',
        'toggle-number': 'Przełącz numer',
    },
    appToast: {
        clubCreated: 'Klub utworzony',
        upgradeSuccessful: 'Upgrade zakończony.',
        subscriptionActivating: 'Subskrypcja jest aktywowana. Odśwież za chwilę.',
        subscriptionFree: 'Subskrypcja zaktualizowana — jesteś teraz na Free.',
        subscriptionPro: 'Subskrypcja zaktualizowana — Pro jest aktywne.',
        subscriptionTeam: 'Subskrypcja zaktualizowana — Team jest aktywne.',
        billingUpdated: 'Płatności zaktualizowane.',
        checkoutCancelled: 'Checkout anulowany',
        welcomeBack: 'Witaj z powrotem.',
        googleLoginStarted: 'Otworzyliśmy logowanie Google w osobnym oknie.',
        googleLoginFailed: 'Logowanie Google nie powiodło się. Spróbuj ponownie.',
        devLogin: 'Zalogowano jako testowy użytkownik {{tier}}',
    },
    storeToast: {
        toolActive: 'Aktywne narzędzie: {{tool}} — kliknij, aby umieścić • Esc kończy',
        zoom: 'Zoom: {{percent}}%',
        zoomFit: 'Zoom: dopasuj',
        backOnline: 'Jesteś online',
        offline: 'Jesteś offline',
        saveFailedRetry: 'Zapis nieudany — ponowimy po powrocie online',
        saveGuestTitle: 'Zapisać pracę?',
        saveGuestDescription: 'Masz niezapisaną pracę z sesji gościa. Zapisać ją na koncie w chmurze?',
        saveGuestConfirm: 'Zapisz w chmurze',
        discard: 'Odrzuć',
        guestWorkSaved: 'Praca została zapisana w chmurze.',
        guestWorkSaveFailed: 'Nie udało się zapisać. Spróbuj ręcznie przez Cmd+S.',
        tools: {
            'player-home': 'Zawodnik gospodarzy',
            'player-away': 'Zawodnik gości',
            ball: 'Piłka',
            'arrow-pass': 'Strzałka podania',
            'arrow-run': 'Strzałka biegu',
            'arrow-shoot': 'Strzałka strzału',
            'arrow-dribble': 'Strzałka dryblingu',
            zone: 'Strefa',
            'zone-ellipse': 'Strefa elipsy',
            'zone-polygon': 'Strefa wielokątna — klikaj punkty, dwuklik kończy',
            text: 'Tekst',
        },
    },
    legal: {
        draftBanner: '⚠ To jest szkic — oczekuje na przegląd prawny.',
        updated: 'Ostatnia aktualizacja: {{date}}',
        back: 'Wróć do TMC Studio',
        privacy: {
            title: 'Polityka prywatności',
            intro: {
                title: '1. Wprowadzenie',
                body: 'TMC Studio („my”, „nasze” lub „nas”) zobowiązuje się chronić Twoją prywatność. Ta Polityka prywatności wyjaśnia, jak zbieramy, używamy, ujawniamy i chronimy Twoje informacje podczas korzystania z naszej aplikacji tablicy taktycznej.',
            },
            collect: {
                title: '2. Informacje, które zbieramy',
                providedTitle: '2.1 Informacje podawane przez Ciebie',
                automaticTitle: '2.2 Informacje zbierane automatycznie',
                provided: {
                    account: 'Informacje o koncie (email, imię i nazwisko)',
                    project: 'Dane projektów (tablice taktyczne, formacje, adnotacje)',
                    payment: 'Informacje płatnicze (przetwarzane bezpiecznie przez Stripe)',
                },
                automatic: {
                    usage: 'Dane użycia i analityka',
                    device: 'Informacje o urządzeniu i przeglądarce',
                    location: 'Adres IP i dane lokalizacyjne',
                },
            },
            use: {
                title: '3. Jak używamy Twoich informacji',
                items: {
                    maintain: 'Świadczymy i utrzymujemy naszą usługę',
                    payments: 'Przetwarzamy płatności i subskrypcje',
                    updates: 'Wysyłamy aktualizacje i powiadomienia',
                    improve: 'Ulepszamy aplikację i doświadczenie użytkownika',
                    legal: 'Spełniamy obowiązki prawne',
                },
            },
            storage: {
                title: '4. Przechowywanie i bezpieczeństwo danych',
                body: 'Twoje dane są przechowywane bezpiecznie w Supabase (baza PostgreSQL) z szyfrowaniem w spoczynku i podczas przesyłania. Stosujemy standardowe środki bezpieczeństwa, aby chronić Twoje informacje.',
            },
            sharing: {
                title: '5. Udostępnianie danych',
                body: 'Nie sprzedajemy Twoich danych osobowych. Możemy udostępniać Twoje dane:',
                stripe: 'do przetwarzania płatności',
                supabase: 'do hostingu danych i uwierzytelniania',
                netlify: 'do hostingu aplikacji',
                sentry: 'do monitorowania błędów (techniczne raporty błędów, bez treści Twoich plansz)',
                postmark: 'do wysyłki wiadomości transakcyjnych (zaproszenia do klubu, odpowiedzi na zgłoszenia błędów)',
                google: 'do logowania kontem Google, jeśli je wybierzesz',
                plausible: 'do anonimowych statystyk użycia, wyłącznie po wyrażeniu zgody na analitykę',
            },
            rights: {
                title: '6. Twoje prawa',
                body: 'Masz prawo do:',
                items: {
                    access: 'Dostępu do swoich danych osobowych',
                    correct: 'Poprawienia nieprawidłowych danych',
                    delete: 'Żądania usunięcia swoich danych',
                    export: 'Eksportu swoich danych',
                    optOut: 'Rezygnacji z komunikacji marketingowej',
                },
            },
            cookies: {
                title: '7. Pliki cookie',
                before: 'Używamy niezbędnych plików cookie do uwierzytelniania i zapisywania preferencji. Możesz kontrolować pliki cookie w ustawieniach przeglądarki. Więcej informacji znajdziesz w naszej',
                link: 'Polityce plików cookie',
                after: '.',
            },
            children: {
                title: '8. Prywatność dzieci',
                body: 'Nasza usługa nie jest przeznaczona dla dzieci poniżej 13 lat. Nie zbieramy świadomie danych osobowych od dzieci.',
            },
            changes: {
                title: '9. Zmiany w tej polityce',
                body: 'Możemy od czasu do czasu aktualizować tę Politykę prywatności. Poinformujemy o zmianach, publikując nową politykę na tej stronie i aktualizując datę „Ostatnia aktualizacja”.',
            },
            contact: {
                title: '10. Kontakt',
                body: 'Jeśli masz pytania dotyczące tej Polityki prywatności, skontaktuj się z nami pod adresem:',
            },
        },
        terms: {
            title: 'Regulamin usługi',
            acceptance: {
                title: '1. Akceptacja warunków',
                body: 'Uzyskując dostęp do TMC Studio („Usługa”) i korzystając z niej, akceptujesz warunki tej umowy i zgadzasz się nimi związany. Jeśli nie zgadzasz się z Regulaminem usługi, nie korzystaj z naszej Usługi.',
            },
            description: {
                title: '2. Opis usługi',
                body: 'TMC Studio to webowa aplikacja tablicy taktycznej dla trenerów i analityków sportowych. Usługa pozwala tworzyć, edytować i udostępniać diagramy taktyczne, formacje oraz sekwencje animowane.',
            },
            accounts: {
                title: '3. Konta użytkowników',
                registrationTitle: '3.1 Rejestracja',
                registration: 'Aby uzyskać dostęp do niektórych funkcji, musisz utworzyć konto. Zgadzasz się podać dokładne, aktualne i kompletne informacje podczas rejestracji.',
                securityTitle: '3.2 Bezpieczeństwo konta',
                security: 'Odpowiadasz za zachowanie poufności danych logowania do konta. Zgadzasz się niezwłocznie powiadomić nas o każdym nieautoryzowanym użyciu konta.',
                terminationTitle: '3.3 Zamknięcie konta',
                termination: 'Zastrzegamy sobie prawo do zawieszenia lub zamknięcia konta, jeśli naruszysz te Warunki albo podejmiesz działania oszukańcze lub nielegalne.',
            },
            payments: {
                title: '4. Subskrypcje i płatności',
                pricingTitle: '4.1 Cennik',
                pricing: 'Oferujemy darmowe i płatne plany subskrypcji. Ceny są widoczne na naszej stronie i mogą zostać zmienione z 30-dniowym wyprzedzeniem.',
                billingTitle: '4.2 Rozliczenia',
                billing: 'Płatne subskrypcje są rozliczane miesięcznie lub rocznie z góry. Płatności są przetwarzane bezpiecznie przez Stripe.',
                refundsTitle: '4.3 Zwroty',
                refunds: 'Prośby o zwrot rozpatrujemy indywidualnie. Skontaktuj się z pomocą techniczną, jeśli uważasz, że przysługuje Ci zwrot.',
                cancellationTitle: '4.4 Anulowanie',
                cancellation: 'Możesz anulować subskrypcję w dowolnym momencie. Anulowanie zaczyna obowiązywać na koniec bieżącego okresu rozliczeniowego.',
            },
            content: {
                title: '5. Treści użytkownika',
                ownershipTitle: '5.1 Własność',
                ownership: 'Zachowujesz wszystkie prawa do tablic taktycznych i treści tworzonych w naszej Usłudze. Nie rościmy sobie praw własności do treści użytkownika.',
                licenseTitle: '5.2 Licencja',
                license: 'Korzystając z naszej Usługi, udzielasz nam ograniczonej licencji na hosting, przechowywanie i wyświetlanie Twoich treści wyłącznie w celu świadczenia Usługi.',
                prohibitedTitle: '5.3 Treści zabronione',
                prohibitedIntro: 'Zgadzasz się nie przesyłać ani nie udostępniać treści, które:',
                prohibited: {
                    laws: 'Naruszają przepisy prawa lub regulacje',
                    ip: 'Naruszają prawa własności intelektualnej',
                    malware: 'Zawierają malware lub szkodliwy kod',
                    offensive: 'Są obraźliwe, nękające lub dyskryminujące',
                },
            },
            acceptable: {
                title: '6. Dopuszczalne użycie',
                intro: 'Zgadzasz się nie:',
                items: {
                    reverse: 'Dokonywać inżynierii wstecznej ani próbować pozyskać kodu źródłowego',
                    automated: 'Używać narzędzi automatycznych do dostępu do Usługi (boty, scrapery)',
                    disrupt: 'Zakłócać działania Usługi',
                    share: 'Udostępniać swojego konta innym osobom',
                    illegal: 'Używać Usługi w jakimkolwiek nielegalnym celu',
                },
            },
            ip: {
                title: '7. Własność intelektualna',
                body: 'Usługa, w tym jej oprogramowanie, projekt, grafiki i treści (z wyłączeniem treści użytkownika), należy do TMC Studio i jest chroniona prawem autorskim, znakami towarowymi oraz innymi przepisami dotyczącymi własności intelektualnej.',
            },
            disclaimers: {
                title: '8. Zastrzeżenia',
                body: 'USŁUGA JEST DOSTARCZANA „TAKA, JAKA JEST”, BEZ JAKICHKOLWIEK GWARANCJI. Nie gwarantujemy, że Usługa będzie działać nieprzerwanie, bezpiecznie lub bez błędów.',
            },
            liability: {
                title: '9. Ograniczenie odpowiedzialności',
                body: 'W MAKSYMALNYM ZAKRESIE DOZWOLONYM PRZEZ PRAWO TMC Studio nie ponosi odpowiedzialności za szkody pośrednie, przypadkowe, szczególne lub wynikowe powstałe w związku z korzystaniem z Usługi.',
            },
            backup: {
                title: '10. Kopie zapasowe danych',
                body: 'Chociaż stosujemy procedury kopii zapasowych, odpowiadasz za utrzymywanie własnych kopii swoich treści. Nie ponosimy odpowiedzialności za utratę danych.',
            },
            changes: {
                title: '11. Zmiany regulaminu',
                body: 'Zastrzegamy sobie prawo do zmiany tych Warunków w dowolnym momencie. O istotnych zmianach poinformujemy użytkowników emailem lub powiadomieniem w aplikacji. Dalsze korzystanie z Usługi oznacza akceptację zmienionych Warunków.',
            },
            law: {
                title: '12. Prawo właściwe',
                body: 'Te Warunki podlegają prawu polskiemu i będą interpretowane zgodnie z nim, bez względu na przepisy kolizyjne.',
            },
            contact: {
                title: '13. Informacje kontaktowe',
                body: 'Jeśli masz pytania dotyczące tych Warunków, skontaktuj się z nami pod adresem:',
            },
        },
        cookies: {
            title: 'Polityka plików cookie',
            what: {
                title: '1. Czym są pliki cookie?',
                body: 'Pliki cookie to małe pliki tekstowe zapisywane na Twoim urządzeniu podczas odwiedzania naszej strony. Pomagają nam zapewnić lepsze doświadczenie, zapamiętując preferencje i rozumiejąc, jak korzystasz z naszej Usługi.',
            },
            use: {
                title: '2. Jak używamy plików cookie',
                body: 'TMC Studio używa plików cookie w następujących celach:',
            },
            types: {
                title: '3. Rodzaje plików cookie, których używamy',
                essentialTitle: '3.1 Niezbędne pliki cookie',
                essentialBody: 'Te pliki cookie są konieczne do prawidłowego działania Usługi. Nie można ich wyłączyć.',
                essential: {
                    authentication: { label: 'Uwierzytelnianie', body: 'Utrzymuje zalogowanie na koncie' },
                    session: { label: 'Zarządzanie sesją', body: 'Utrzymuje sesję podczas korzystania z aplikacji' },
                    security: { label: 'Bezpieczeństwo', body: 'Chroni przed atakami CSRF i zapewnia bezpieczną komunikację' },
                },
                preferenceTitle: '3.2 Pliki cookie preferencji',
                preferenceBody: 'Te pliki cookie zapamiętują Twoje ustawienia i preferencje:',
                preference: {
                    theme: { label: 'Motyw', body: 'Zapamiętuje preferencję trybu ciemnego/jasnego' },
                    language: { label: 'Język', body: 'Przechowuje wybrany język' },
                    ui: { label: 'Ustawienia UI', body: 'Zapisuje stan panelu inspektora, poziom zoomu itp.' },
                },
                analyticsTitle: '3.3 Analityczne pliki cookie (opcjonalne)',
                analyticsBody: 'Te pliki cookie pomagają nam zrozumieć, jak odwiedzający korzystają z naszej Usługi:',
                analytics: {
                    usage: { label: 'Wzorce użycia', body: 'Które funkcje są najpopularniejsze' },
                    performance: { label: 'Wydajność', body: 'Jak szybko ładują się strony' },
                    errors: { label: 'Śledzenie błędów', body: 'Identyfikuje problemy techniczne' },
                },
                analyticsNote: 'Za Twoją zgodą używamy dbającej o prywatność analityki Plausible do pomiaru użycia produktu i błędów. Nie tworzymy profili reklamowych.',
            },
            thirdParty: {
                title: '4. Pliki cookie stron trzecich',
                body: 'Korzystamy z następujących usług stron trzecich, które mogą ustawiać pliki cookie:',
                supabase: 'do uwierzytelniania i przechowywania danych',
                stripe: 'do bezpiecznego przetwarzania płatności',
                policies: 'Te usługi mają własne polityki prywatności i plików cookie:',
                supabasePolicy: 'Polityka prywatności Supabase',
                stripePolicy: 'Polityka prywatności Stripe',
            },
            localStorage: {
                title: '5. Local storage',
                body: 'Oprócz plików cookie używamy local storage przeglądarki, aby:',
                items: {
                    cache: 'Cache’ować tablice taktyczne do dostępu offline',
                    state: 'Przechowywać stan aplikacji między sesjami',
                    project: 'Zapamiętywać ostatnio edytowany projekt',
                },
            },
            manage: {
                title: '6. Zarządzanie plikami cookie',
                browserTitle: '6.1 Kontrola w przeglądarce',
                browserBody: 'Większość przeglądarek pozwala kontrolować pliki cookie w ustawieniach. Możesz:',
                browser: {
                    blockAll: 'Blokować wszystkie pliki cookie',
                    blockThirdParty: 'Blokować tylko pliki cookie stron trzecich',
                    deleteSession: 'Usuwać pliki cookie po każdej sesji',
                    viewDelete: 'Wyświetlać i usuwać konkretne pliki cookie',
                },
                impactTitle: '6.2 Skutki blokowania plików cookie',
                important: 'Ważne:',
                impactBody: 'Jeśli zablokujesz niezbędne pliki cookie, nie będzie można się zalogować ani korzystać z funkcji chmurowych. Pliki cookie preferencji można blokować z minimalnym wpływem na działanie aplikacji.',
                changeConsent: 'Zmień zgodę na analitykę',
            },
            duration: {
                title: '7. Czas przechowywania plików cookie',
                sessionTitle: 'Sesyjne pliki cookie',
                sessionBody: 'Usuwane po zamknięciu przeglądarki',
                persistentTitle: 'Trwałe pliki cookie',
                persistentBody: 'Pozostają do 1 roku albo do czasu ich usunięcia',
            },
            updates: {
                title: '8. Aktualizacje tej polityki',
                body: 'Możemy od czasu do czasu aktualizować tę Politykę plików cookie. O istotnych zmianach poinformujemy, aktualizując datę „Ostatnia aktualizacja” u góry tej strony.',
            },
            contact: {
                title: '9. Kontakt',
                body: 'Jeśli masz pytania dotyczące używania przez nas plików cookie, skontaktuj się z nami pod adresem:',
            },
        },
        refunds: {
            title: 'Zwroty i anulowanie',
            intro: 'Ta strona wyjaśnia zasady anulowania subskrypcji, prawa odstąpienia od umowy oraz kontaktu w sprawach płatności za TMC Studio.',
            withdrawalTitle: 'Prawo odstąpienia',
            withdrawalBody: 'Jeżeli zawierasz umowę jako konsument w Unii Europejskiej, możesz mieć prawo odstąpić od umowy w terminie 14 dni, chyba że wyrazisz zgodę na rozpoczęcie świadczenia usługi cyfrowej przed upływem tego terminu.',
            waiverTitle: 'Rozpoczęcie świadczenia usługi cyfrowej',
            waiverBody: 'Dostęp do funkcji płatnych może rozpocząć się od razu po zakupie. W takim przypadku, zgodnie z obowiązującymi przepisami, prawo odstąpienia może wygasnąć po rozpoczęciu świadczenia usługi za Twoją zgodą.',
            cancelTitle: 'Anulowanie subskrypcji',
            cancelBody: 'Subskrypcję możesz anulować w dowolnym momencie w panelu konta i płatności. Dostęp do płatnych funkcji pozostaje aktywny do końca opłaconego okresu rozliczeniowego.',
            refundTitle: 'Zwroty',
            refundBody: 'Zwroty rozpatrujemy indywidualnie, szczególnie przy błędnym obciążeniu, problemach technicznych lub zdublowanej płatności. Płatności są obsługiwane przez Stripe.',
            contactTitle: 'Kontakt w sprawie płatności',
            contactBody: 'Napisz do nas, jeśli potrzebujesz pomocy z anulowaniem, fakturą lub zwrotem:',
        },
        legalNotice: {
            title: 'Nota prawna',
            intro: 'Informacje o podmiocie odpowiedzialnym za TMC Studio i dane kontaktowe.',
            providerTitle: 'Usługodawca',
            registeredAt: 'Data rejestracji: {{date}}',
            contactTitle: 'Kontakt',
            contactBody: 'W sprawach prawnych i formalnych skontaktuj się z nami pod adresem:',
            vatTitle: 'Identyfikacja podatkowa',
            vatBody: 'Numer NIP: {{nip}}. Płatności online są przetwarzane przez Stripe.',
            responsibleTitle: 'Odpowiedzialność za treści',
            responsibleBody: 'Dokładamy starań, aby informacje w serwisie były aktualne i rzetelne. Treści tworzone przez użytkowników pozostają odpowiedzialnością ich autorów.',
        },
        accessibility: {
            title: 'Dostępność',
            commitmentTitle: 'Nasze zobowiązanie',
            commitmentBody: 'Chcemy, aby TMC Studio było możliwie dostępne dla trenerów, analityków i twórców korzystających z różnych urządzeń oraz technologii wspomagających.',
            statusTitle: 'Aktualny status',
            statusBody: 'Aplikacja jest stale rozwijana. Pracujemy nad czytelnością interfejsu, obsługą klawiatury, kontrastem oraz stabilnością układów na mniejszych ekranach.',
            feedbackTitle: 'Uwagi i zgłoszenia',
            feedbackBody: 'Jeśli zauważysz barierę dostępności albo element, który utrudnia korzystanie z aplikacji, napisz do nas:',
        },
    },
    organizationPanel: {
        title: 'Klub',
        seats: 'Wykorzystane miejsca: {{used}} / {{max}}',
        upsell: {
            description: 'Zapraszaj trenerów i sztab do swojego klubu po przejściu na plan Team.',
            cta: 'Przejdź na plan Team',
        },
        intro: {
            title: 'Jak to działa',
            step1: '1. Utwórz swój klub i nadaj mu nazwę.',
            step2: '2. Utwórz bezpieczny link zaproszenia i udostępnij go członkowi sztabu.',
            step3: '3. Każdy członek ma dostęp do wspólnych projektów klubu.',
        },
        create: {
            description: 'Stwórz swój klub, aby zapraszać trenerów i członków sztabu.',
            nameLabel: 'Nazwa klubu',
            namePlaceholder: 'np. Akademia Młodzieżowa FC Przykład',
            cta: 'Utwórz klub',
            creating: 'Tworzenie…',
        },
        members: {
            title: 'Członkowie',
            remove: 'Usuń',
            leave: 'Opuść klub',
            leaving: 'Opuszczanie…',
            transferOwnership: 'Przekaż własność klubu',
            transferSelect: 'Wybierz nowego właściciela…',
            transferConfirm: 'Przekaż',
            transferring: 'Przekazywanie…',
            cancel: 'Anuluj',
            deleteClub: 'Usuń klub',
            deleteClubConfirm: 'Usunąć ten klub na zawsze? Tej operacji nie można odwrócić.',
            deleteClubConfirmCta: 'Tak, usuń',
            deleting: 'Usuwanie…',
        },
        invite: {
            title: 'Zaproszenia',
            emailPlaceholder: 'trener@przyklad.pl',
            cta: 'Wyślij zaproszenie',
            sending: 'Wysyłanie…',
            pending: 'Oczekujące zaproszenia',
            copyLink: 'Skopiuj link',
            linkCopied: 'Link skopiowany!',
            revoke: 'Anuluj',
            seatLimitReached: 'Osiągnięto limit miejsc w planie Team. Usuń członka albo zwiększ plan, aby zaprosić kolejne osoby.',
            shareHint: 'TMC Studio wyśle bezpieczne zaproszenie mailem. Link nadal możesz skopiować z oczekujących zaproszeń.',
            sent: 'Zaproszenie wysłano na {{email}}.',
        },
        roles: {
            owner: 'Właściciel',
            member: 'Członek',
        },
        memberAccess: {
            title: 'Jesteś członkiem klubu {{club}}',
            description: 'Masz dostęp do wspólnych projektów i materiałów tego klubu.',
        },
        errors: {
            createFailed: 'Nie udało się utworzyć klubu. Spróbuj ponownie.',
            inviteFailed: 'Nie udało się wysłać zaproszenia. Spróbuj ponownie.',
            invalidRequest: 'Żądanie zaproszenia jest nieprawidłowe.',
            invalidEmail: 'Wpisz prawidłowy adres email.',
            notAuthorized: 'Tylko właściciel klubu może wysyłać zaproszenia.',
            notAuthenticated: 'Zaloguj się ponownie przed wysłaniem zaproszenia.',
            teamRequired: 'Do zapraszania członków wymagany jest aktywny plan Team.',
            seatLimitReached: 'Osiągnięto limit miejsc w planie Team.',
            alreadyMember: 'Ta osoba jest już członkiem klubu.',
            alreadyPending: 'Zaproszenie dla tego adresu już oczekuje.',
            deliveryFailed: 'Nie udało się dostarczyć maila. Oczekujące zaproszenie nie zostało utworzone.',
            configurationError: 'Wysyłka zaproszeń jest tymczasowo niedostępna.',
            rateLimited: 'Wysłano zbyt wiele zaproszeń. Odczekaj minutę i spróbuj ponownie.',
            transferFailed: 'Nie udało się przekazać własności klubu. Spróbuj ponownie.',
            deleteFailed: 'Nie udało się usunąć klubu. Spróbuj ponownie.',
            leaveFailed: 'Nie udało się opuścić klubu. Spróbuj ponownie.',
        },
        welcome: {
            title: 'Witaj w Club Premium!',
            subtitle: 'Skonfiguruj swój klub w 3 prostych krokach',
            nameTeamLabel: 'Nazwij swój klub',
            nameTeamPlaceholder: 'np. FC Przykład Aktywna Młodzież',
            continue: 'Dalej',
            skip: 'Zrobię to później',
            inviteTitle: 'Zaproś pierwszego członka',
            inviteDescription: 'Otwórz panel Drużyny, aby zaprosić trenerów i sztab do swojego klubu.',
            teamPanelHint: 'Otwórz panel Drużyny w Inspektorze',
            teamPanelDesc: 'Dodawaj członków przez email — od razu zyskują dostęp do Club Premium',
            openTeamPanel: 'Otwórz panel Drużyny',
            doLater: 'Zaproś później',
            completeTitle: 'Wszystko gotowe!',
            completeDescription: 'Twój klub jest gotowy. Oto co możesz teraz robić:',
            benefitUnlimited: 'Nielimitowane projekty i kroki',
            benefitExport: 'Eksport GIF, PDF i więcej',
            benefitMembers: 'Zarządzaj do 5 członkami drużyny',
            startCoaching: 'Zacznij trenować',
        },
    },
    invitePage: {
        loading: 'Wczytywanie zaproszenia…',
        goToApp: 'Przejdź do TMC Studio',
        notFound: {
            title: 'Zaproszenie nie znalezione',
            description: 'Ten link zaproszenia jest nieprawidłowy. Poproś administratora klubu o nowy link.',
        },
        expired: {
            title: 'Zaproszenie już nieaktywne',
            description: 'To zaproszenie wygasło lub zostało anulowane. Poproś administratora klubu o nowe.',
        },
        declined: {
            title: 'Zaproszenie odrzucone',
            description: 'Odrzuciłeś zaproszenie do {{club}}. Jeśli zmienisz zdanie, administrator klubu może wysłać nowe.',
        },
        accepted: {
            title: 'Jesteś w klubie!',
            description: 'Dołączyłeś do klubu {{club}}.',
        },
        ready: {
            title: 'Zostałeś zaproszony',
            description: 'Zostałeś zaproszony do klubu {{club}} jako {{role}} ({{email}}).',
            signInPrompt: 'Zaloguj się lub utwórz konto na adres {{email}}, aby zaakceptować zaproszenie.',
            signIn: 'Zaloguj się',
            wrongAccount: 'To zaproszenie zostało wysłane na adres {{invited}}, ale jesteś zalogowany jako {{current}}. Zaloguj się na zaproszony adres e-mail.',
            accept: 'Zaakceptuj zaproszenie',
            accepting: 'Dołączanie…',
            decline: 'Odrzuć zaproszenie',
            declining: 'Odrzucanie…',
        },
        errors: {
            acceptFailed: 'Nie udało się zaakceptować zaproszenia. Spróbuj ponownie.',
            declineFailed: 'Nie udało się odrzucić zaproszenia. Spróbuj ponownie.',
        },
    },
    languages: {
        pl: 'Polski',
        en: 'English',
        es: 'Español',
    },
    pageNotFound: {
        title: 'Nie znaleziono strony',
        description: 'Ten adres nie istnieje albo został przeniesiony.',
        cta: 'Otwórz tablicę',
    },
};
//# sourceMappingURL=pl.js.map